import { Box, CircularProgress, Grid, Hidden, IconButton, Snackbar, SnackbarContent, Stack, Typography } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";
import * as AppActions from "../../store/actions/App.Actions";
import * as ContactActions from "../../store/actions/Contact.Actions";
import * as OrderActions from "../../store/actions/Order.Actions";
import * as PaymentActions from "../../store/actions/Payment.Action";
import * as OrganizationActions from "../../store/actions/Organization.Actions";
import { getRooms } from "../../store/actions/RoomActions";
import { getSettingAreas } from "../../store/actions/SettingAreasActions";
import * as LocalStorage from "../../utilities/LocalStorage";
import { CheckBox, CheckBoxOutlineBlank, Close, ClearOutlined, DeleteOutlined } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import moment from "moment";
import { NavLink } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { v4 as uuidv4 } from "uuid";
import ItemQtyDropdown from "../../components/ItemQtyDropdown";
import { DialogContent, DialogTitle } from "../../components/dialog/DialogTitle";
import IAddress from "../../models/IAddress";
import IOrder from "../../models/IOrder";
import IOrderItem from "../../models/IOrderItem";
import IPaymentTransaction from "../../models/IPaymentTransaction";
import { formatMoney } from "../../pipes/PriceFormatter";
import { getEventEndTime, normalizePhoneInput, replaceComma, showString, } from "../../services/HelperFunctions";
import { checkIfOpenUsingHoursandScheduledTime, getDay, getFormattedHolidays, getWeeklySchedule,  roundToNext15Min, } from "../../services/IsClosed";
import { AppState } from "../../state/AppState";
import { openProductDetailPageModel } from "../../store/actions/App.Actions";
import { createGuestOrder, getCalculatedPayment, getPaymentCardDetails, getUndeliverablePostalCodes, postCreatePaymentLink, postPaymentForOrder, getCalculatedEstimatedTime, getSetupIntentDetail, validatetOrders, validateMenuCategoryItems, } from "../../store/actions/CheckoutActions";
import { UpsertAddress } from "../../store/actions/CustomerActions";
import { selectedCategoryMenuProduct } from "../../store/actions/Menu.Action";
import { getFormatedNiceDate } from "../../utilities/GetFormatedNiceDate";
import { withRouter } from "../../utilities/withRouter";
// import "./ProceedToCheckout.css";
import { getCheckedOptions, getReorderModifiersPrice, transformArrayFromModifiers, } from "../../utilities/modifiers";
import { getEventPicklistsOptions, getPickListsByOrganization, } from "../../store/actions/Organization.Actions";
import { Auth0WithOutRedirect } from "../../services/Utilities";
import useGrazeAuth0Lock from "../../utilities/hooks/useGrazeAuth0Lock";
import axios, { AxiosError, AxiosResponse } from "axios";
import SkipifyIntegration from "../../components/SkipifyIntegration";
import formatDateForTimezone from "../../utilities/formatedTimeZoneFunction";
import { formatPhoneNumberInput } from "../../utilities/FormatPhoneNumber";
import { getTodayOpenHours } from "../../utilities/startendTimeoptions";
import { roundToNextFifteenMinutes } from "../../utilities/roundToNextFifteenMinutes";
import { styles, StyledTextField, StyledPayButton, } from "../../utilities/styles/checkoutPage.style";
import { IPageProps, IPageState } from "../../models/ICheckoutPageState";
import { LoginUser } from "../../components/ProceedToCheckout/LoginUser";
import { handlePayNow } from "../../utilities/ProceedToCheckout/payNow";
import { getGrazePaymentStatus, isGrazePaymentPayload, toPaymentTransaction } from "../../utilities/ProceedToCheckout/paymentDetail";
import { IStripeSetupIntentMessage, isStripeSetupIntentMessage, toStripeChargePayload, toStripePaymentTransaction } from "../../utilities/ProceedToCheckout/stripePayment";
import IGrazePaymentPayload from "../../models/IGrazePaymentPayload";
import { handlePayLater } from "../../utilities/ProceedToCheckout/payLater";
import OrderTypeSelector from "../../components/ProceedToCheckout/OrderTypeSelector";
import ClientInformationForm from "../../components/ProceedToCheckout/ClientInformationForm";
import EventInformationForm from "../../components/ProceedToCheckout/EventInformationForm";
import ContactInformationSection from "../../components/ProceedToCheckout/ContactInformationSection";
import GuestCountSection from "../../components/ProceedToCheckout/GuestCountSection";
import AdditionalDetailsAccordion from "../../components/ProceedToCheckout/AdditionalDetailsAccordion";
import EventAddressSection from "../../components/ProceedToCheckout/EventAddressSection";
import DeliveryAddressSection from "../../components/ProceedToCheckout/DeliveryAddressSection";
import OrderSummarySection from "../../components/ProceedToCheckout/OrderSummarySection";
import PaymentSection from "../../components/ProceedToCheckout/PaymentSection";
import PaymentDetails from "../../components/ProceedToCheckout/PaymentDetails";
import OpenHoursDialog from "../../components/ProceedToCheckout/OpenHoursDialogue";
import StorePolicyDialog from "../../components/ProceedToCheckout/StorePolicyDialog";
import PickupDeliveryTimeSelector from "../../components/ProceedToCheckout/PickupDeliveryTimeSelector";
import OrderNotesSection from "../../components/ProceedToCheckout/OrderNotesSection";
import OrderSummaryMobile from "../../components/ProceedToCheckout/OrderSummaryMobile";
import { isClosed } from "../../services/IsClosed";
const classNames = require("classnames");

function Auth0Provider({ children }: { children: any }) {
  const { isAuthenticated, isLoading, user } = useGrazeAuth0Lock();
  useEffect(() => {
    if (!isAuthenticated && !isLoading && !user) {
      Auth0WithOutRedirect.show();
    }
  }, [isAuthenticated, isLoading, user]);
  return children;
}

class ProceedToCheckout extends React.Component<IPageProps, IPageState> {
  public validator: SimpleReactValidator = new SimpleReactValidator();
  public cardFormValidator: SimpleReactValidator = new SimpleReactValidator();
  public calculateEstimatedTimeTimer: any = null;
  public timeOutList: any = null;
  public paymentPayloadObject: any = null;
  public timer: NodeJS.Timeout | null = null;
  private paymentFrame = React.createRef<HTMLIFrameElement>();
  private activePayment: { paymentNumber: string; processorType: number; amountCents: number; applySurcharge: boolean } | null = null;
  private paymentCompleted = false;
  private paymentSubmitted = false;
  private stripePaymentInProgress = false;

  constructor(props: any) {
    super(props);

    const start = roundToNext15Min(moment(new Date()));
    const end = start.clone().add(15, "minutes");

    this.state = {
      eventFieldStartTime: start.toDate(),
      eventFieldEndTime: end.toDate(),
      requestedPickupAndDeliveryTime: start.toDate(),
      pickupWindow: 0,
      deliveryWindow: 0,
      dateUpdatedMessage: "",
      timeUpdatedMessage: "",
      eventDateUpdatedMessage: "",
      eventTimeUpdatedMessage: "",
      showStorePolicy: false,
      isOpenScheduleReturnedMessage: false,
      backecndEstimatedTime: null,
      orderCreateError: false,
      orderCreateErrorMessage: "",
      organizationAddress: null,
      isDiscounts: false,
      companyLogo: "",
      firstName: "",
      discount: "",
      discountTotal: 0,
      lastName: "",
      phoneNumber: "",
      email: "",
      addressName: "",
      address1: "",
      city: "",
      county: "",
      postalCode: "",
      stateProvince: "",
      country: "United States",
      notes: "",
      openPayMethodModel: false,
      openOpenHoursModel: false,
      openPolicyModel: false,
      paymentURL: process.env.REACT_APP_PAYMENT_URL || "",
      paymentDialogHeight: "100vh",
      orderType: LocalStorage.get(LocalStorage.keys.orderType) || "Pickup",
      scheduleForLater: false,
      showAsap: false,
      selectedDate: new Date(),
      selectedDateError: "",
      eventSelectedEndDate: moment(new Date()).add({ hours: 1 }).toDate(),
      orderMinimum: 0,
      orderMinimumMessage: "",
      onlineOrderClosedMessage: "",
      undeliverableZoneMessage: "",
      onlineOrderEnabled: true,
      throttlingBuffer: 0,
      throttlingOverloadMessage: "",
      estimatedReadyTimeMax: new Date(),
      orderSaveRequest: false,
      couponCode: "",
      couponError: false,
      guest: true,
      newAddress: false,
      saveNewAddress: false,
      latitude: 0,
      longitude: 0,
      companyName: "",
      eventName: "",
      dateOfEvent: "",
      expectedGuestCount: 1,
      eventStartTime: "",
      eventEndTime: "",
      theme: "",
      category: "",
      eventNotes: "",
      selectedRoom: null,
      selectedSetupStyle: null,
      detailsExpended: true,
      newOrderQuantity: {},
      onlineOrderTermsMessage: "",
      qtyError: {},
      operation: "",
      creatingOrder: false,
      forceLogin: false,
      paymentPayload: null,
      paymentConfirmation: null,
      laterSchedDate: new Date(),
      openHoursList: null,
      currentDateWithSelectedTime: new Date(),
      minimumPickupDate: new Date(),
      calculateEstimatedTimeLoading: false,
      eventDate: new Date(),
      eventStart: new Date(),
      eventEnd: new Date(new Date().getTime() + 15 * 60000),
      appUserState: null,
      cardDetailsLoader: true,
      totalTax: 0,
      serviceChargeTotal: 0,
      gratuityTotal: 0,
      total: 0,
      subtotal: 0,
      calculatePaymentLoading: false,
      savedAddresses: null,
      selectedAddressId: "",
      undeliverablePostalCodes: null,
      undeliverableDistances: null,
      undeliverableTravelTime: null,
      deliveryFee: 0,
      loadPaymentUrl: false,
      pickListThemeOptions: null,
      pickListCategoryOptions: null,
      pickListByOrganization: null,
      pickListOperationOptions: null,
      distanceInMiles: 0,
      travelTimeInMins: 0,
      calculatedEstimatedTimeFromAPI: null,
      saveAddress: false,
      pickupDeliveryTime: moment(new Date()).format("HH:mm"),
      paymentDeclineError: null,
      skipifyGuid: "",
      skipifyPayButtonLoading: false,
      creatingOrderWithSkipify: false,
      skipifyResponse: null,
      skipifySuccessOrderID: null,
      skipifyClose: false,
      skipifyPopupOpen: false,
      selectedOption: "",
      selectedNames: "",
      orderPickListOptions: [],
      requiredFieldsError: false,
      requiredFields: [] as string[],
      guestCountError: "",
      showGuestCountError: false,
    };

    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  public handleRadioChange(event: any) {
    const scheduleForLater = !this.state.scheduleForLater;

    this.setState({ scheduleForLater, laterSchedDate: new Date() });
  }

  public handleDateChange = async (moment: any) => {
    const { estimatedReadyTimeMax } = this.state;
    let selectedDate = new Date(moment);
    const invalidDate = isNaN(selectedDate.getTime());
    let selectedDateError = "";

    if (invalidDate) {
      return;
    }

    if (estimatedReadyTimeMax && selectedDate < estimatedReadyTimeMax) {
      selectedDate = estimatedReadyTimeMax;
      selectedDateError = `Earliest ready time is ${getFormatedNiceDate(
        selectedDate
      )}`;
    }

    const onlineOrderEnabled = true;
    const throttlingBuffer = 0;

    if (!onlineOrderEnabled) {
      selectedDateError = `Kitchen is closed on ${getFormatedNiceDate(
        selectedDate
      )}`;
    }

    this.setState({
      selectedDate,
      selectedDateError,
      onlineOrderEnabled,
      throttlingBuffer,
    });
  };

  private checkUserProfile = (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      const contactInfo = this.getContactInfoFromLocalStorage();
      if (contactInfo) {
        this.setState(
          {
            ...this.state,
            ...contactInfo,
          },
          () => resolve(null)
        );
        return;
      } else {
        const { customer } = this.props;
        if (!customer || customer.firstName === "Guest") {
          this.setState(
            {
              ...this.state,
            },
            () => resolve(null)
          );
          return;
        }

        this.setState(
          {
            firstName: showString(customer?.firstName),
            lastName: showString(customer.lastName),
            phoneNumber: showString(customer.phone),
            email: showString(customer.email),
          },
          () => resolve(customer)
        );
      }
    });
  };

  private handlePhone = ({ target: { value } }: any) => {
    this.setState({
      phoneNumber: normalizePhoneInput(
        value,
        this.state?.phoneNumber ? this.state?.phoneNumber : ""
      ),
    });
  };

  private handleMessage = async (event: MessageEvent) => {
    if (!this.state.paymentURL ||
        event.source !== this.paymentFrame.current?.contentWindow ||
        event.origin !== new URL(this.state.paymentURL).origin) {
      return;
    }
    let data = event.data;
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (error) {
        return;
      }
    }
    if (!data || typeof data !== "object") {
      return;
    }
    if (data.id === "set-height") {
      this.setState({ paymentDialogHeight: data.height });
    } else if (isGrazePaymentPayload(data)) {
      await this.handleGrazePayment(data);
    } else if (isStripeSetupIntentMessage(data)) {
      await this.handleStripeSetupIntent(data);
    }
  };

  private handleGrazePayment = async (payload: IGrazePaymentPayload): Promise<void> => {
    const payment = this.activePayment;
    if (!payment || this.paymentCompleted) {
      return;
    }
    if (payload.paymentNumber && payload.paymentNumber !== payment.paymentNumber) {
      console.warn("Ignoring payment message for a different payment link.");
      return;
    }
    const status = getGrazePaymentStatus(payload);
    if (status !== "paid") {
      this.paymentSubmitted = false;
      const state = payload.state || payload.hPayPaymentTransactions?.[0]?.state;
      this.setState({
        cardDetailsLoader: false,
        openPayMethodModel: true,
        paymentDeclineError: status === "failed"
          ? `Payment ${state?.toLowerCase() || "failed"}. Please try again in the payment form.`
          : "Payment could not be confirmed. Please contact the merchant before attempting another payment.",
      });
      return;
    }
    let paymentTransaction: IPaymentTransaction;
    try {
      paymentTransaction = toPaymentTransaction(payload, !!this.props.organizationSettings?.applySurcharge);
    } catch (error) {
      console.error("Invalid payment message:", error);
      this.setState({
        openPayMethodModel: true,
        paymentDeclineError: "Payment could not be confirmed. Please contact the merchant before attempting another payment.",
      });
      return;
    }
    this.paymentSubmitted = true;
    this.paymentCompleted = true;
    this.setState({ paymentConfirmation: paymentTransaction, paymentDeclineError: null, openPayMethodModel: true });
    try {
      await this.checkAppUserAvailable();
      if (this.activePayment !== payment) {
        return;
      }
      // Wait for state to flush: the order request reads creatingOrder/appUserState from this.state.
      await new Promise<void>((resolve) =>
        this.setState({ cardDetailsLoader: false, creatingOrder: true }, resolve)
      );
      await this.createOrderGuestWithTransactionDetails(paymentTransaction);
    } catch (error) {
      console.error("Unable to create order after payment:", error);
      this.setState({
        creatingOrder: false,
        orderCreateError: true,
        orderCreateErrorMessage: "Payment was received, but the order could not be completed. Please contact the merchant; do not pay again.",
      });
    }
  };

  // Stripe (acct_) links only save the card in the iframe (SetupIntent), so the charge is made here:
  // /completegraze → card details → validate order → /graze/payments → create order.
  private handleStripeSetupIntent = async (message: IStripeSetupIntentMessage): Promise<void> => {
    const payment = this.activePayment;
    if (!payment || payment.processorType !== 3 || this.paymentCompleted || this.stripePaymentInProgress) {
      return;
    }
    this.stripePaymentInProgress = true;
    const { firstName, lastName, email } = this.state;
    const merchantAccount = this.props.organizationSettings?.merchantAccount;
    // A paymentPayload swaps the iframe for a spinner; clearing it reloads the iframe so the guest can try again.
    const showPaymentError = (paymentDeclineError: string) => {
      this.stripePaymentInProgress = false;
      this.setState({ paymentPayload: null, cardDetailsLoader: false, openPayMethodModel: true, paymentDeclineError });
    };
    this.setState({ paymentPayload: message, cardDetailsLoader: true, paymentDeclineError: null });
    let chargeSent = false;
    try {
      const setupResponse = await this.props.getSetupIntentDetails({
        pi_guid: message.setupIntent.id,
        setup_intent_client_secret: message.setupIntent.client_secret,
        setup_intent: message.setupIntent.id,
        acct_id: merchantAccount,
        tipAmount: message.tipAmount,
        totalAmount: message.totalAmount,
      });
      if (setupResponse?.status !== 200 || !setupResponse.payload) {
        throw new Error("Unable to complete the setup intent.");
      }
      const setupPayload = { ...setupResponse.payload, merchantId: merchantAccount };
      const cardDetails = await this.getStripeCardDetails(setupPayload);
      if (!cardDetails) {
        showPaymentError("Unable to verify this card. Please try again or use a different card.");
        return;
      }
      const validationResponse = await this.props.validateGuestOrder(this.prepareOrderPayload());
      if (validationResponse?.status !== 200) {
        this.stripePaymentInProgress = false;
        this.setState({
          cardDetailsLoader: false,
          openPayMethodModel: false,
          paymentPayload: null,
          orderCreateError: true,
          orderCreateErrorMessage: "There has been an error validating your Order, please try again.",
        });
        return;
      }
      await this.checkAppUserAvailable();
      if (this.activePayment !== payment) {
        return;
      }
      const charge = toStripeChargePayload(setupPayload, { name: `${firstName} ${lastName}`, email }, merchantAccount, payment);
      chargeSent = true;
      const paymentResponse = await this.props.postPaymentForOrder(charge, payment.processorType);
      if (paymentResponse?.status === 403) {
        this.stripePaymentInProgress = false;
        this.setState({
          cardDetailsLoader: false,
          openPayMethodModel: false,
          paymentPayload: null,
          orderCreateError: true,
          orderCreateErrorMessage: "Transaction Failed, Please contact Merchant",
        });
        return;
      }
      if (paymentResponse?.error_code) {
        showPaymentError(paymentResponse.error_message || "Payment declined. Please try again in the payment form.");
        return;
      }
      const paymentTransaction = toStripePaymentTransaction(paymentResponse, cardDetails, charge, payment);
      this.paymentSubmitted = true;
      this.paymentCompleted = true;
      // Wait for state to flush: the order request reads creatingOrder/appUserState from this.state.
      await new Promise<void>((resolve) =>
        this.setState({ paymentConfirmation: paymentTransaction, cardDetailsLoader: false, creatingOrder: true }, resolve)
      );
      await this.createOrderGuestWithTransactionDetails(paymentTransaction);
    } catch (error) {
      console.error("Unable to complete Stripe payment:", error);
      if (this.paymentCompleted) {
        this.setState({
          creatingOrder: false,
          orderCreateError: true,
          orderCreateErrorMessage: "Payment was received, but the order could not be completed. Please contact the merchant; do not pay again.",
        });
      } else {
        showPaymentError(chargeSent
          ? "Payment could not be confirmed. Please contact the merchant before attempting another payment."
          : "Payment could not be completed. Please try again in the payment form.");
      }
    }
  };

  // Up to four attempts, as before PR 8550.
  private getStripeCardDetails = async (setupPayload: any): Promise<any> => {
    const { user } = this.props;
    const { firstName, lastName, email } = this.state;
    const payload = {
      paymentMethodId: setupPayload.paymentMethodId,
      currency: setupPayload.currency,
      payerEmail: user?.email ? user.email : email,
      nameOnCard: user?.name ? user.name : `${firstName} ${lastName}`,
      merchantId: setupPayload.merchantId,
    };
    for (let attempt = 0; attempt < 4; attempt++) {
      const response = await this.props.getPaymentCardDetails(payload);
      if (response?.id) {
        return response;
      }
    }
    return null;
  };

  private validateOrderMenuCategoryItems = async () => {
        const { order, validateMenuCategoryItems } = this.props;
        const menuCategoryItems = order.orderItems.map((item: any) => item?.menuCategoryItem?.id);
        const response = await validateMenuCategoryItems({
                "organizationId": this.props.organizations?.organization?.id,
                "menuCategoryItems": menuCategoryItems
            });
        if(response?.data?.menuCategoryItems && response?.data?.menuCategoryItems.length > 0) {
            window.location.reload();
        }
  }

  private onhandleChange = (event: any, fieldName: string) => {
    const value = event.target.value;
    this.setState({ [fieldName]: value } as IPageState, () => {
      this.setContactInfoOnLocalStorage();

      if (fieldName === "eventStartTime" || fieldName === "dateOfEvent") {
        this.handleDateChange(
          `${this.state.dateOfEvent} ${this.state.eventStartTime}`
        );
      }

      if (fieldName === "deliveryTime") {
        this.handleDateChange(
          `${this.state.selectedDate.toLocaleDateString()} ${value}`
        );
      }
    });
  };

  private handleClickOpenPayMethodModel = () => {
    this.setState({ openPayMethodModel: true });
  };

  private handleClosePayMethodModel = () => {
    this.setState({ openPayMethodModel: false, paymentPayload: null });
  };

  // iOS only: stop auto-zoom on payment form fields while the payment dialog is open; pinch-zoom still works
  private setPaymentZoomLock = (lock: boolean) => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (!isIOS) return;
    const content = 'width=device-width, initial-scale=1, shrink-to-fit=no';
    document.querySelector('meta[name="viewport"]')?.setAttribute('content', lock ? `${content}, maximum-scale=1` : content);
  };

  private handleCloseOpenHoursModel = () => {
    this.setState({ openOpenHoursModel: false });
  };

  private handleClosePolicyModel = () => {
    this.setState({ openPolicyModel: false });
  };

  private onSaveNewAddressChecked = () => {
    this.setState({
      saveNewAddress: !this.state.saveNewAddress,
    });
  };

  private saveOrder = async (
    placeOrder: boolean = false
  ): Promise<IOrder | null> => {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      addressName,
      address1,
      postalCode,
      city,
      stateProvince,
      notes,
      orderType,
      scheduleForLater,
      selectedDate,
      estimatedReadyTimeMax,
      saveNewAddress,
      guest,
      latitude,
      longitude,
      companyName,
      eventName,
      dateOfEvent,
      expectedGuestCount,
      eventStartTime,
      eventEndTime,
      theme,
      category,
      eventNotes,
      selectedRoom,
      selectedSetupStyle,
      operation,
    } = this.state;
    const { order, orderPut, locationId } = this.props;

    try {
      const updatedOrder: IOrder = {
        ...order,
        asap: !scheduleForLater,
        requestedDateTime: scheduleForLater
          ? selectedDate
          : estimatedReadyTimeMax,
        locationId: locationId ? locationId : order.locationId,
        customerName: `${firstName} ${lastName}`,
        customerPhone: phoneNumber,
        customerEmail: email,
        notes,
        type: orderType,
        orderStatus: null,
        operation,
        orderEventDetails: {
          ...order.orderEventDetails,
          expectedGuestCount,
        },
      };

      if ((orderType === "Delivery" || orderType === "Event") && !!address1) {
        updatedOrder.orderDelivery = {
          ...order.orderDelivery,
          notes,
          name: addressName,
          address1,
          city,
          stateProvince,
          postalCode,
          latitude,
          longitude,
        };
      }

      if (orderType === "Event") {
        updatedOrder.orderEventDetails = {
          ...order.orderEventDetails,
          companyName,
          eventName,
          dateOfEvent,
          expectedGuestCount,
          eventStartTime,
          eventEndTime,
          theme,
          category,
          eventNotes,
          banquetRoomId: selectedRoom?.id,
          banquetRoom: selectedRoom?.name,
          setupStyle: selectedSetupStyle?.name,
        };
      }

      if (placeOrder) {
        this.resetContactInfoOnLocalStorage();

        if (saveNewAddress && !guest) {
          const newAddress: IAddress = {
            address1,
            city,
            stateProvince,
            postalCode,
            default: false,
            latitude,
            longitude,
            name: addressName,
          };

          this.props.upsertAddress(newAddress);
        }
      }

      const { newOrderQuantity } = this.state;
      const newQuantityItemIds = Object.keys(newOrderQuantity);
      if (newQuantityItemIds.length) {
        newQuantityItemIds.forEach((key: any) => {
          const newQuantity = newOrderQuantity[key];
          const updatedItem = updatedOrder?.orderItems?.find(
            (item) => item.id === Number(key)
          );
          if (updatedItem) {
            updatedItem.quantity = newQuantity;
          }
        });
      }

      return orderPut(updatedOrder, placeOrder);
    } catch (e) {
      console.error(e);
    }

    return null;
  };

  private orderSetDefault = (orderId: number) => {
    this.props.orderSetDefault();
    LocalStorage.save(LocalStorage.keys.lastOnlineOrder, orderId);
    this.props.router?.navigate(`/order/${orderId}`);
  };

  private payNow = async (event: any) => {
    if (this.activePayment) {
      event.preventDefault();
      this.handleClickOpenPayMethodModel();
      return;
    }
    await handlePayNow(event, {
      state: this.state as any,
      organizationSettings: this.props.organizationSettings,
      organization: this.props.organization,
      appUserDetails: this.props.appUserDetails,
      order: this.props.order,
      validateGuestCount: this.validateGuestCount,
      validateMenuCategoryItems: this.props.validateMenuCategoryItems,
      validateOrder: () => this.props.validateGuestOrder(this.prepareOrderPayload()),
      postCreatePaymentLink: this.props.postCreatePaymentLink,
      orderRemoveItem: this.orderRemoveItem as any,
      getCalculatedEstimatedTimeFromAPI: () => this.getCalculatedEstimatedTimeFromAPI(),
      handleClickOpenPayMethodModel: this.handleClickOpenPayMethodModel,
      fetchCalculatedEstimatedTime: this.props.fetchCalculatedEstimatedTime,
      getOrganizationOrdersOpenSchedule: this.props.getOrganizationOrdersOpenSchedule,
      setState: (updates) => this.setState(updates),
      onPaymentLinkCreated: (paymentNumber, processorType, amountCents, applySurcharge) => {
        this.activePayment = { paymentNumber, processorType, amountCents, applySurcharge };
      },
    });
  };

  private checkAppUserAvailable = async () => {
    const { appUserDetails, user, organizations } = this.props;
    if (!appUserDetails && user) {
      await this.props
        .getUserByEmailId(user.email)
        .then(async (response: any) => {
          if (!response.successful) {
            const payload: any = [
              {
                organizationId: organizations?.organization?.id,
                organizationDomainName: organizations?.organization?.domainName,
                userName: user.nickname,
                firstName: user.name,
                lastName: user.name,
                emailAddress: user.email,
                userType: "User",
              },
            ];
            await this.props
              .registerUser(payload)
              .then((res: any) => {
                this.setState(
                  {
                    appUserState: Array.isArray(res.data)
                      ? res.data[0]
                      : res.data,
                  },
                  () => { }
                );
              })
              .catch((err: any) => {
                console.error("::::::: error ", err);
              });
          } else {
            this.setState({
              appUserState: Array.isArray(response.data)
                ? response.data[0]
                : response.data,
            });
          }
        })
        .catch((err: any) => {
          console.error("::::::: error ", err);
        });
    }
  };

  public getOrganizationAddress = async () => {
    const { getOrganizations } = this.props;
    await getOrganizations().then((res: any) => {
        if (res?.data) {
          const organizationAddress = {
            address1: res.data[0].address1,
            address2: res.data[0].address2,
            city: res.data[0].city,
            stateProvince: res.data[0].stateProvince,
            postalCode: res.data[0].postalCode,
            county: res.data[0].county,
            country: res.data[0].country,
          };
          this.setState({ organizationAddress });
        }
      })
      .catch((err: any) => {
        console.error("::::::: error ", err);
      });
  }

  public getOrderDeliveryAddress = () => {
    const {
      orderType,
      address1,
      city,
      stateProvince,
      postalCode,
      country,
      addressName,
      savedAddresses,
      selectedAddressId,
      distanceInMiles,
      travelTimeInMins,
      county,
    } = this.state;
    const isBahamas = (countryStr: string | undefined) => {
      if (!countryStr) return false;
      const trimmed = countryStr.trim().toLowerCase();
      return trimmed === "the bahamas" || trimmed === "bs";
    };

    if (orderType === "Delivery") {
      if (savedAddresses?.length > 0) {
        const selectedAddress = savedAddresses?.find((address: any) => {
          return address?.id === selectedAddressId;
        });
        const selectedCountry = selectedAddress?.country || country;
        const selectedPostalCode = isBahamas(selectedCountry)
          ? "111111"
          : selectedAddress?.postalCode || postalCode;
        return {
          name: selectedAddress?.name || addressName,
          address1: replaceComma(selectedAddress?.address1 || address1),
          address2: selectedAddress?.address2,
          city: selectedAddress?.city || city,
          stateProvince: selectedAddress?.stateProvince || stateProvince,
          postalCode: selectedPostalCode,
          country: selectedAddress?.country || "United States",
          estimatedDriveDuration: travelTimeInMins,
          distanceInMiles: distanceInMiles,
          county:
            selectedAddress?.county ||
            county ||
            this.props.organization?.county,
        };
      } else {
        const selectedCountry = country;
        const selectedPostalCode = isBahamas(selectedCountry)
          ? "111111"
          : postalCode;
        return {
          address1: replaceComma(address1),
          name: addressName,
          city,
          stateProvince,
          postalCode: selectedPostalCode,
          country: country || "United States",
          estimatedDriveDuration: travelTimeInMins,
          distanceInMiles: distanceInMiles,
          county: county || this.props.organization?.county,
        };
      }
    } else if (orderType === "Event") {
      const selectedAddress = savedAddresses?.find((address: any) => {
        return address?.id === selectedAddressId;
      });
      if (!selectedAddress && !address1) {
        return null;
      }
      const selectedCountry = selectedAddress?.country || country;
      const selectedPostalCode = isBahamas(selectedCountry)
        ? "111111"
        : selectedAddress?.postalCode || postalCode;

      return {
        address1: replaceComma(selectedAddress?.address1 || address1),
        city: selectedAddress?.city || city,
        stateProvince: selectedAddress?.stateProvince || stateProvince,
        name: selectedAddress?.name || addressName,
        postalCode: selectedPostalCode,
        country: country || "United States",
        estimatedDriveDuration: travelTimeInMins,
        distanceInMiles: distanceInMiles,
        county: county || this.props.organization?.county,
      };
    }
    return null;
  };

  public getCounty = () => {
    const {
      orderType,
      address1,
      stateProvince,
      savedAddresses,
      selectedAddressId,
      county,
    } = this.state;
    const { organization } = this.props;

    if (orderType === "Delivery") {
      if (savedAddresses?.length > 0) {
        const selectedAddress = savedAddresses?.find((address: any) => {
          return address?.id === selectedAddressId;
        });
        return {
          county: selectedAddress?.county || county,
          state: selectedAddress?.stateProvince || stateProvince,
        };
      } else {
        return {
          county,
          state: stateProvince,
        };
      }
    } else if (orderType === "Pickup") {
      return {
        county: organization?.county,
        state: organization?.stateProvince,
      };
    } else if (orderType === "Event") {
      const selectedAddress = savedAddresses?.find((address: any) => {
        return address?.id === selectedAddressId;
      });
      if (!selectedAddress && !address1) {
        return {
          county: organization?.county,
          state: organization?.stateProvince,
        };
      }
      return {
        county: selectedAddress?.county || county,
        state: selectedAddress?.stateProvince || stateProvince,
      };
    }
    return null;
  };

  private prepareOrderPayload = () => {
    const { order, organization, oidc, pickListByOrganization } = this.props;

    const {
      notes,
      serviceChargeTotal,
      totalTax,
      gratuityTotal,
      orderType,
      expectedGuestCount,
      firstName,
      lastName,
      phoneNumber,
      email,
      laterSchedDate,
      category,
      theme,
      companyName,
      eventName,
      eventDate,
    } = this.state;

    const orderItems = order.orderItems.map((item: any) => ({
      notes: item.notes || "",
      orderItemModifiers:
        item.modifiers?.map((modifier: any) => ({
          menuItemModifierId: modifier.id,
          options:
            modifier.options?.map((option: any) => ({
              menuItemModifierOptionId: option.id,
              menuItemModifierSubOptionIds:
                option.subOptions?.map((sub: any) => sub.id) || [],
            })) || [],
        })) || [],
      menuCategoryItemId: item.menuCategoryItem?.id,
      quantity: item.quantity,
    }));

    const start =
      moment(eventDate).format("YYYY-MM-DD") +
      moment(this.state.eventFieldStartTime).utc().format("THH:mm:ss.SSS[Z]");
    const end =
      moment(eventDate).format("YYYY-MM-DD") +
      moment(this.state.eventFieldEndTime).utc().format("THH:mm:ss.SSS[Z]");
    const newRequestedDateTime = moment(laterSchedDate)
      .hour(moment(this.state.requestedPickupAndDeliveryTime).hour())
      .minute(moment(this.state.requestedPickupAndDeliveryTime).minute())
      .second(0)
      .millisecond(0)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

    const payload = [
      {
        organizationId: organization?.id,
        userId: oidc?.user?.profile?.sub,
        notes,
        serviceCharge: serviceChargeTotal,
        tax: totalTax,
        gratuity: gratuityTotal,
        orderItems,
        orderPickListOptions: this.state.orderPickListOptions,
        orderType,
        orderStatusType: "New",
        expectedGuestCount,
        customerFirstName: firstName,
        customerLastName: lastName,
        customerPhone: phoneNumber,
        phoneNumber: phoneNumber,
        customerEmail: email,
        email: email,
        requestedDateTime: newRequestedDateTime,
        orderDeliveryAddress: orderType === 'Pickup' ? this.state.organizationAddress : this.getOrderDeliveryAddress(),
        orderEventDetails:
          orderType === "Event"
            ? {
              categoryId: category || null,
              themeId: theme || null,
              company: companyName,
              eventName,
              eventStartTime: start,
              eventEndTime: end,
            }
            : null,
      },
    ];

    return payload;
  };

  private createOrderGuestWithTransactionDetails = async (
    paymentTransaction: IPaymentTransaction
  ) => {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      notes,
      orderType,
      companyName,
      addressName,
      address1,
      city,
      stateProvince,
      postalCode,
      country,
      savedAddresses,
      saveAddress,
      eventName,
      expectedGuestCount,
      eventDate,
      laterSchedDate,
      appUserState,
      eventNotes,
      category,
      theme,
      county,
    } = this.state;
    const { organizations, organizationSettings } = this.props;
    const orderItems: any[] = [];
    this.props.order?.orderItems?.forEach((orderItem: IOrderItem) => {
      delete orderItem.menuCategoryItem;
      orderItem.organization = { id: organizations?.organization?.id };
      orderItems.push({
        notes: orderItem?.notes,
        orderItemModifiers: transformArrayFromModifiers(
          orderItem?.orderItemModifiers
        ),
        menuCategoryItemId: orderItem?.menuCategoryItemId,
        quantity: orderItem?.quantity,
      });
    });
    const start = moment(eventDate)
      .hour(moment(this.state.eventFieldStartTime).hour())
      .minute(moment(this.state.eventFieldStartTime).minute())
      .second(0)
      .millisecond(0)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const end = moment(eventDate)
      .hour(moment(this.state.eventFieldEndTime).hour())
      .minute(moment(this.state.eventFieldEndTime).minute())
      .second(0)
      .millisecond(0)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const newRequestedDateTime = moment(laterSchedDate)
      .hour(moment(this.state.requestedPickupAndDeliveryTime).hour())
      .minute(moment(this.state.requestedPickupAndDeliveryTime).minute())
      .second(0)
      .millisecond(0)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

    const payload = [
      {
        organizationId: organizations?.organization?.id,
        orderItems: orderItems,
        orderRevenueTypeRates: [],
        orderType,
        userId: appUserState?.id ? appUserState.id : null,
        orderStatusType: "New",
        customerFirstName: firstName,
        customerLastName: lastName,
        customerPhone: phoneNumber,
        customerEmail: email,
        notes: orderType === "Event" ? eventNotes : notes,
        isAsap: false,
        requestedDateTime: orderType === "Event" ? start : newRequestedDateTime,
        orderDeliveryAddress: orderType === 'Pickup' ? this.state.organizationAddress : this.getOrderDeliveryAddress(),
        expectedGuestCount:
          orderType === "Event"
            ? expectedGuestCount
            : organizationSettings?.enableGuestCount
              ? expectedGuestCount
              : 0,
        orderPaymentTransactions: [paymentTransaction],
        orderEventDetails:
          orderType === "Event"
            ? {
              categoryId: category || null,
              themeId: theme || null,
              company: companyName,
              eventName: eventName,
              eventStartTime: start,
              eventEndTime: end,
            }
            : null,
        user: {
          organizationId: organizations?.organization?.id,
          id: appUserState?.id ? appUserState.id : null,
        },
        ...(this.state.discountTotal > 0 && {
          discountCode: this.state.discount,
        }),
      },
    ];
    const addressPayload = [
      {
        name: addressName,
        address1: replaceComma(address1),
        city,
        county,
        stateProvince,
        postalCode,
        country: country || "United States",
        isDefault: savedAddresses?.length === 0 ? true : false,
      },
    ];
    if (this.state.creatingOrder) {
      await this.props
        .createOrderGuest(payload)
        .then(async (response: any) => {
          this.setState({ creatingOrder: false });
          if (response?.status === 200) {
            if (saveAddress) {
              await this.props.createNewAddress(addressPayload);
            }
            this.props.clearCart();
            this.props.router?.navigate(
              `/order-confirmed/${response?.data[0]?.id}`
            );
            localStorage.removeItem("order");
            localStorage.removeItem("requestedPickupDateTime");
            localStorage.removeItem("eventEndDateTime");
          } else {
            const messageParts = response?.message?.split(".\n") || [];
            const errorMessage =
              messageParts.length > 1 ? messageParts[1] : response?.message;
            this.setState({
              orderCreateError: true,
              orderCreateErrorMessage:
                this.paymentCompleted
                  ? "Payment was received, but the order could not be completed. Please contact the merchant; do not pay again."
                  : errorMessage === "You can't create an order in the past"
                  ? "Please select a Date and Time in the future"
                  : errorMessage,
              creatingOrder: false,
              openPayMethodModel: false,
              paymentPayload: null,
            });
          }
        })
        .catch((err: any) => {
          this.setState({
            creatingOrder: false,
            orderCreateError: true,
            orderCreateErrorMessage: "Payment was received, but the order could not be completed. Please contact the merchant; do not pay again.",
          });
          console.error("::::::: error create Order", err);
        });
    }
  };

  private createOrderGuestWithSkipifyTransactionDetails = async (
    paymentTransaction: IPaymentTransaction
  ) => {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      notes,
      orderType,
      companyName,
      addressName,
      address1,
      city,
      stateProvince,
      postalCode,
      country,
      savedAddresses,
      saveAddress,
      eventName,
      expectedGuestCount,
      eventDate,
      laterSchedDate,
      appUserState,
      eventNotes,
      category,
      theme,
      county,
      orderPickListOptions,
    } = this.state;
    const { organizations, organizationSettings } = this.props;
    const orderItems: any[] = [];
    this.props.order?.orderItems?.forEach((orderItem: IOrderItem) => {
      delete orderItem.menuCategoryItem;
      orderItem.organization = { id: organizations?.organization?.id };
      orderItems.push({
        notes: orderItem?.notes,
        orderItemModifiers: transformArrayFromModifiers(
          orderItem?.orderItemModifiers
        ),
        menuCategoryItemId: orderItem?.menuCategoryItemId,
        quantity: orderItem?.quantity,
      });
    });
    const start = moment(eventDate)
      .hour(moment(this.state.eventFieldStartTime).hour())
      .minute(moment(this.state.eventFieldStartTime).minute())
      .second(0)
      .millisecond(0)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const end = moment(eventDate)
      .hour(moment(this.state.eventFieldEndTime).hour())
      .minute(moment(this.state.eventFieldEndTime).minute())
      .second(0)
      .millisecond(0)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const newRequestedDateTime = moment(laterSchedDate)
      .hour(moment(this.state.requestedPickupAndDeliveryTime).hour())
      .minute(moment(this.state.requestedPickupAndDeliveryTime).minute())
      .second(0)
      .millisecond(0)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

    const payload = [
      {
        organizationId: organizations?.organization?.id,
        orderItems: orderItems,
        orderRevenueTypeRates: [],
        orderType,
        userId: appUserState?.id ? appUserState.id : null,
        orderStatusType: "New",
        customerFirstName: firstName,
        customerLastName: lastName,
        customerPhone: phoneNumber,
        customerEmail: email,
        notes: orderType === "Event" ? eventNotes : notes,
        isAsap: false,
        requestedDateTime: orderType === "Event" ? start : newRequestedDateTime,
        orderDeliveryAddress: orderType === 'Pickup' ? this.state.organizationAddress : this.getOrderDeliveryAddress(),
        expectedGuestCount:
          orderType === "Event"
            ? expectedGuestCount
            : organizationSettings?.enableGuestCount
              ? expectedGuestCount
              : 0,
        orderPaymentTransactions: [paymentTransaction],
        orderPickListOptions: orderPickListOptions || [],
        orderEventDetails:
          orderType === "Event"
            ? {
              categoryId: category || null,
              themeId: theme || null,
              company: companyName,
              eventName: eventName,
              eventStartTime: start,
              eventEndTime: end,
            }
            : null,
        user: {
          organizationId: organizations?.organization?.id,
          id: appUserState?.id ? appUserState.id : null,
        },
        ...(this.state.discountTotal > 0 && {
          discountCode: this.state.discount,
        }),
      },
    ];
    const addressPayload = [
      {
        name: addressName,
        address1: replaceComma(address1),
        city,
        county,
        stateProvince,
        postalCode,
        country: country || "United States",
        isDefault: savedAddresses?.length === 0 ? true : false,
      },
    ];
    await this.props.createOrderGuest(payload).then(async (response: any) => {
      if (response?.status === 200) {
        if (saveAddress) {
          await this.props.createNewAddress(addressPayload);
        }
        this.setState({
          creatingOrderWithSkipify: false,
          skipifyResponse: null,
        });
        this.props.clearCart();
        localStorage.removeItem("order");
        localStorage.removeItem("requestedPickupDateTime");
        localStorage.removeItem("eventEndDateTime");
        this.setState({ skipifySuccessOrderID: response?.data[0]?.id });
      } else {
        const messageParts = response?.message.split(".\n");
        const errorMessage =
          messageParts.length > 1 ? messageParts[1] : response?.message;
        this.setState({
          creatingOrderWithSkipify: false,
          orderCreateError: true,
          orderCreateErrorMessage:
            errorMessage === "You can't create an order in the past"
              ? "Please select a Date and Time in the future"
              : errorMessage,
          creatingOrder: false,
          openPayMethodModel: false,
          paymentPayload: null,
          skipifyResponse: null,
        });
      }
    });
  };

  validateGuestCount = () => {
    if (
      this.state.orderType === "Event" &&
      (this.state.expectedGuestCount === "" ||
        parseInt(this.state.expectedGuestCount) === 0 ||
        isNaN(parseInt(this.state.expectedGuestCount)))
    ) {
      this.setState({
        guestCountError: "Expected Guest Count should be 1 or more",
        showGuestCountError: true,
      });
      return false;
    }

    this.setState({
      guestCountError: "",
      showGuestCountError: false,
    });
    return true;
  };

  isEventDateValid = () => {
    const { eventDate } = this.state;

    if (!eventDate) return false;

    if (!(eventDate instanceof Date) || isNaN(eventDate.getTime()))
      return false;

    const dateString = moment(eventDate).format("YYYY-MM-DD");
    const parts = dateString.split("-");

    if (parts.length !== 3) return false;
    if (parts[0].length !== 4 || parts[1].length !== 2 || parts[2].length !== 2)
      return false;

    return true;
  };

  isEmailValid = () => {
    const { email } = this.state;

    if (!email || email.trim() === "") return false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  private discountTotalCode = async () => {
    const { discount } = this.state;
    this.setState({ calculatePaymentLoading: true });
    const ordItems = this.props.order?.orderItems?.map((item: any) => {
      return {
        menuCategoryItemId: item?.menuCategoryItemId,
        quantity: item?.quantity,
        orderItemModifiers: transformArrayFromModifiers(
          item?.orderItemModifiers
        ),
        notes: item?.notes,
      };
    });
    const body = {
      orderItems: ordItems,
      discountName: discount,
      additionalChargeSources:
        this.state.orderType === "Delivery"
          ? {
            deliveryPostalCode: this.getOrderDeliveryAddress()?.postalCode,
            estimatedDriveDuration: this.state.travelTimeInMins,
            distanceInMiles: this.state.distanceInMiles,
          }
          : {},
      orderRevenueTypeCounty: this.getCounty(),
    };
    this.props.fetchCalculatedPayment(body).then((res: any) => {
      if (res?.successful) {
        this.setState(
          {
            calculatePaymentLoading: false,
            totalTax: res?.data?.taxTotal,
            total: res?.data?.total,
            subtotal: res?.data?.subTotal,
            serviceChargeTotal: res?.data?.serviceCharge,
            gratuityTotal: res?.data?.gratuity,
            deliveryFee: res?.data?.deliveryFee,
            discountTotal: res?.data?.discountTotal,
          },
          () => {
            this.callSkipifyEndpoint();
          }
        );
      } else if (res?.message.includes(`${this.state.discount} used`)) {
        this.setState({
          orderCreateError: true,
          orderCreateErrorMessage: "Discount Code has already been used",
          calculatePaymentLoading: false,
        });
      } else {
        this.setState({
          orderCreateError: true,
          orderCreateErrorMessage: "Invalid Discount Code",
          calculatePaymentLoading: false,
        });
      }
    });
  };

  private payLaterInProgress = false;

  private payLater = async () => {
    if (this.payLaterInProgress) {
      return;
    }
    this.payLaterInProgress = true;
    this.setState({ creatingOrder: true });

    try {
      await this.submitPayLater();
    } finally {
      this.payLaterInProgress = false;
      this.setState({ creatingOrder: false });
    }
  };

  private submitPayLater = async () => {
    await handlePayLater({
      state: this.state as any,
      organizationSettings: this.props.organizationSettings,
      organizations: this.props.organizations,
      order: this.props.order,
      appUserDetails: this.props.appUserDetails,
      validateGuestCount: this.validateGuestCount,
      validateMenuCategoryItems: this.props.validateMenuCategoryItems,
      createOrderGuest: this.props.createOrderGuest,
      createNewAddress: this.props.createNewAddress,
      clearCart: this.props.clearCart,
      orderRemoveItem: this.orderRemoveItem,
      getCalculatedEstimatedTimeFromAPI: () => this.getCalculatedEstimatedTimeFromAPI(),
      fetchCalculatedEstimatedTime: this.props.fetchCalculatedEstimatedTime,
      getOrganizationOrdersOpenSchedule: this.props.getOrganizationOrdersOpenSchedule,
      checkAppUserAvailable: this.checkAppUserAvailable,
      getOrderDeliveryAddress: this.getOrderDeliveryAddress,
      organizationAddress: this.state.organizationAddress,
      setState: (updates) => this.setState(updates),
      router: this.props.router,
    });
  };

  private handleSkipifyClick = async (value: boolean) => {
    if (value) {
      try {
        const orderPayload = this.prepareOrderPayload();
        const validationResponse = await this.props.validateGuestOrder(
          orderPayload
        );
        const validationMessage = Object.values(validationResponse)
          .filter((v) => typeof v === "string")
          .join("");
        if (validationMessage !== "Validation successfully passed") {
          this.setState({
            orderCreateError: true,
            orderCreateErrorMessage:
              "There has been an error validating your Order, please try again.",
            skipifyPopupOpen: false,
          });
          return;
        }
        this.setState({
          orderCreateError: false,
          orderCreateErrorMessage: "",
          skipifyPopupOpen: true,
        });
      } catch (err) {
        this.setState({
          orderCreateError: true,
          orderCreateErrorMessage:
            "Something went wrong while validating your Order.",
          skipifyPopupOpen: false,
        });
      }
    } else {
      this.setState({ skipifyPopupOpen: false });
    }
  };

  private skipifySuccess = async () => {
    this.setState({
      creatingOrderWithSkipify: true,
    });
    const { skipifyResponse } = this.state;

    const pollPaymentDetails = async (retries = 50, delay = 2000) => {
      for (let i = 0; i < retries; i++) {
        try {
          const response: any = await this.getCartPaymentDetailsSkipify();
          const data = response?.data;

          if (data?.pspTransactionId) {
            return data; // This will exit the function and stop the loop
          }

          console.log(`No pspTransactionId yet, retrying in ${delay}ms...`);
        } catch (error) {
          console.error(
            `Error fetching payment details (attempt ${i + 1}):`,
            error
          );
        }

        // Only wait if we're not on the last iteration
        if (i < retries - 1) {
          await new Promise((resolve) => setTimeout(resolve, delay));
        }
      }
      throw new Error("Timeout waiting for pspTransactionId.");
    };

    try {
      const paymentDetails = await pollPaymentDetails();

      this.createOrderGuestWithSkipifyTransactionDetails({
        cCTransactionId: paymentDetails.pspTransactionId,
        paymentProcessorTransactionId: paymentDetails.pspTransactionId,
        transactionState: 3,
        transactionType: "Online",
        paymentMethod: "Credit Card",
        cardIssuer:
          skipifyResponse?.data?.customerInfo?.paymentMethod?.cardBrand,
        maskedCardNumber:
          skipifyResponse?.data?.customerInfo?.paymentMethod?.last4CardNumber,
        madeBy: skipifyResponse?.data?.customerInfo?.email,
        comment: "skipify",
        cCPostal: skipifyResponse?.data?.billingAddress?.zipCode,
        cCStatus: "Completed",
        paymentMethodId: "t1_tok_00000000000000000",
        cCAuthCode: "",
        totalPaid: skipifyResponse?.data?.total?.value / 100 || 0,
        totalTip: skipifyResponse?.data?.tipAmount?.value / 100 || 0,
        totalRefund: 0,
        dateApplied: new Date(),
        totalSurcharge:
          skipifyResponse?.data?.fees.find(
            (fee: any) => fee.type === "surcharge"
          )?.value / 100 || 0,
      });
    } catch (error) {
      console.error("Failed to retrieve pspTransactionId:", error);
      this.setState({
        creatingOrderWithSkipify: false,
      });
    }
  };

  private setOrderType = (orderType: "Delivery" | "Pickup" | "Event") => {
    const { getOrganizationOrdersOpenSchedule } = this.props;
    this.setState(
      {
        orderType,
        address1: "",
        city: "",
        country: "",
        postalCode: "",
        stateProvince: "",
        distanceInMiles: 0,
        travelTimeInMins: 0,
        dateUpdatedMessage: "",
        timeUpdatedMessage: "",
        eventDateUpdatedMessage: "",
        eventTimeUpdatedMessage: "",
      },
      async () => {
        const response = await getOrganizationOrdersOpenSchedule(this.state.orderType);
        this.getCalculatedEstimatedTimeFromAPI(this.state.orderType);
        const isScheduleNotFound = !response?.data;
        if (isScheduleNotFound) {
          await getOrganizationOrdersOpenSchedule("Base");
          this.getCalculatedEstimatedTimeFromAPI("Base");
          this.setState({ isOpenScheduleReturnedMessage: true });
        } else {
          this.setState({ isOpenScheduleReturnedMessage: false });
        }
        this.determineShowStorePolicy(isScheduleNotFound);
        this.getCalculatedDistanceAndTravelTime();
      }
    );
  };

  private backToProductEdit = (product: IOrderItem | any) => {
    this.props.selectedCategoryMenuProduct(product?.menuCategoryItem, product);
    this.props.openProductDetailPageModel();
  };

  private getContactInfoFromLocalStorage = () => {
    return LocalStorage.get<any>(LocalStorage.keys.contactInfo);
  };

  private setContactInfoOnLocalStorage = () => {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      address1,
      city,
      postalCode,
      stateProvince,
      notes,
      companyName,
      eventName,
      dateOfEvent,
      expectedGuestCount,
      eventStartTime,
      eventEndTime,
      theme,
      category,
      eventNotes,
      selectedRoom,
      selectedSetupStyle,
      detailsExpended,
      operation,
    } = this.state;
    const contactInfo = {
      firstName,
      lastName,
      phoneNumber,
      email,
      address1,
      city,
      postalCode,
      stateProvince,
      notes,
      companyName,
      eventName,
      dateOfEvent,
      expectedGuestCount,
      eventStartTime,
      eventEndTime,
      theme,
      category,
      eventNotes,
      selectedRoom,
      selectedSetupStyle,
      detailsExpended,
      operation,
    };
    LocalStorage.save(LocalStorage.keys.contactInfo, contactInfo);
  };

  private resetContactInfoOnLocalStorage = () => {
    LocalStorage.remove(LocalStorage.keys.contactInfo);
  };

  private completeOrderSaveRequest = (): Promise<IOrder> => {
    return new Promise((resolve, reject) => {
      this.setState(
        { orderSaveRequest: false, estimatedTimeCheck: new Date() },
        async () => {
          const order: any = await this.saveOrder();
          this.calculateEstimatedTime();

          resolve(order);
        }
      );
    });
  };

  private orderRemoveItem = async (id: number): Promise<IOrder> => {
    return new Promise((resolve, reject) => {
      this.setState(
        { orderSaveRequest: false, estimatedTimeCheck: new Date() },
        async () => {
          const order = await this.props.orderRemoveItem(id);
          this.calculateEstimatedTime();

          resolve(order);
          const items = localStorage.getItem("order");
          if (items) {
            const orderParsed = JSON.parse(items);
            if (orderParsed?.orderItems?.length === 1) {
              localStorage.removeItem("order");
            }
          }
        }
      );
    });
  };

  public calculateEstimatedTime = () => {
    const { order } = this.props;
    const {
      orderType,
      scheduleForLater,
      estimatedTimeCheck,
      address1,
      throttlingBuffer,
    } = this.state;
    const throttlingBufferMs =
      !!throttlingBuffer && throttlingBuffer > 0
        ? throttlingBuffer * 60 * 1000
        : 0;
    let estimatedReadyTime: any;
    if (order) {
      estimatedReadyTime = new Date(
        order?.estimatedReadyTimeMin
          ? order.estimatedReadyTimeMin
          : order.estimatedReadyTimeMax
      ).getTime();
    }

    const estimatedDriveDurationMs =
      orderType === "Delivery" &&
        !!address1 &&
        !!order.orderDelivery &&
        !!order.orderDelivery.estimatedDriveDuration &&
        !!order.orderDelivery.address1
        ? order.orderDelivery.estimatedDriveDuration * 1000
        : 0;

    const dateCheckOffset = estimatedTimeCheck
      ? Date.now() - estimatedTimeCheck.getTime()
      : Date.now();
    const estimatedReadyTimeMax = new Date(
      estimatedReadyTime +
      estimatedDriveDurationMs +
      throttlingBufferMs +
      dateCheckOffset
    );
    const selectedDate =
      scheduleForLater && estimatedReadyTimeMax <= this.state.selectedDate
        ? this.state.selectedDate
        : estimatedReadyTimeMax;

    this.setState({ estimatedReadyTimeMax }, () =>
      this.handleDateChange(selectedDate)
    );
  };

  private renderOnlineOrderClosedMessage = (
    onlineOrderEnabled: boolean | undefined,
    onlineOrderClosedMessage: string
  ) => {
    const { classes } = this.props;
    return (
      onlineOrderEnabled === false &&
      onlineOrderClosedMessage && (
        <Grid item={true} xs={12} sm={12}>
          <div className={classes.orderMessage}>{onlineOrderClosedMessage}</div>
        </Grid>
      )
    );
  };

  private renderOnlineOrderTermsMessage = (
    onlineOrderClosedMessage: string,
    onlineOrderTermsMessage: string
  ) => {
    const { classes } = this.props;

    return (
      !onlineOrderClosedMessage &&
      onlineOrderTermsMessage && (
        <Grid item={true} xs={12} sm={12}>
          <div className={classes.orderMessage}>{onlineOrderTermsMessage}</div>
        </Grid>
      )
    );
  };

  private renderUndeliverableZoneMessage = (
    undeliverableZone: boolean,
    undeliverableZoneMessage: string
  ) => {
    const { classes } = this.props;

    return (
      undeliverableZone &&
      !!undeliverableZoneMessage && (
        <Grid item={true} xs={12} sm={12}>
          <div className={classes.orderMessage}>{undeliverableZoneMessage}</div>
        </Grid>
      )
    );
  };

  private renderThrottlingOverloadMessage = (
    throttlingOverload: boolean,
    throttlingOverloadMessage: string
  ) => {
    const { classes } = this.props;

    return (
      throttlingOverload &&
      !!throttlingOverloadMessage && (
        <Grid item={true} xs={12} sm={12}>
          <div className={classes.orderMessage}>
            {throttlingOverloadMessage}
          </div>
        </Grid>
      )
    );
  };

  private renderSaveToProfile = () => {
    const { classes } = this.props;
    const { guest, saveNewAddress } = this.state;

    return (
      !guest && (
        <Grid item={true} xs={12} sm={4}>
          <FormControlLabel
            classes={{ label: classes.formControlLabel }}
            label={<span>Save to profile</span>}
            control={
              <Checkbox
                checked={saveNewAddress}
                size="small"
                icon={<CheckBoxOutlineBlank className={classes.sizeIcon} />}
                checkedIcon={<CheckBox className={classes.sizeIcon} />}
                onClick={() => this.onSaveNewAddressChecked()}
              />
            }
          />
        </Grid>
      )
    );
  };

  private couponButtonClick = async (removeCouponState: boolean) => {
    const { applyCoupon, removeCoupon, order } = this.props;
    const { couponCode } = this.state;

    let updatedOrder: any = null;
    if (removeCouponState) {
      updatedOrder = await removeCoupon(order.id);
      if (!!updatedOrder) {
        this.setState({
          couponCode: "",
          couponError: false,
        });
      }
    } else {
      updatedOrder = await applyCoupon(order.id, couponCode);
      if (!updatedOrder) {
        this.setState({
          couponCode: order.coupon?.code ? order.coupon.code : "",
          couponError: true,
        });
      }
    }
  };

  private onUpdateItemQuantity = (
    orderItem: IOrderItem,
    newQuantity: number
  ) => {
    const configuredMinQty =
      orderItem?.menuCategoryItem?.menuItem?.minimumQuantity;
    const qtyError: any = { ...this.state.qtyError };

    if (configuredMinQty && configuredMinQty > newQuantity) {
      qtyError[orderItem.id] = `Min qty: ${configuredMinQty}`;
      newQuantity = configuredMinQty;
    }

    const newOrderQuantity = { ...this.state.newOrderQuantity };
    newOrderQuantity[orderItem.id] = newQuantity;

    this.setState(
      {
        ...this.state,
        newOrderQuantity,
        qtyError,
      },
      () => {
        this.setState({ orderSaveRequest: true });
        setTimeout(() => {
          this.setState({
            qtyError: {},
          });
        }, 5000);
      }
    );
  };

  private determineShowStorePolicy = (isScheduleNotFound: boolean) => {
  const { organizationSettings } = this.props;
  const { orderType } = this.state;

  let advanceNoticeHours = 0;

  if (isScheduleNotFound) {
    advanceNoticeHours = organizationSettings?.ordersAdvanceNoticeHours ?? 0;
  } else {
    if (orderType === "Pickup") {
      advanceNoticeHours = organizationSettings?.ordersAdvanceNoticeHoursPickUp ?? 0;
    } else if (orderType === "Delivery") {
      advanceNoticeHours = organizationSettings?.ordersAdvanceNoticeHoursDelivery ?? 0;
    } else if (orderType === "Event") {
      advanceNoticeHours = organizationSettings?.ordersAdvanceNoticeHoursEvent ?? 0;
    }
  }

  const hasOverride = 
    !!organizationSettings?.advancedNoticePolicyOverride ||  !!organizationSettings?.additionalNoticeOverride;

  this.setState({ showStorePolicy: advanceNoticeHours > 0 || hasOverride});
};

  private goToDashboard = () => {
    this.props.router?.navigate("/dashboard");
  };

  public componentWillMount = () => {
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        address: {
          message: "The :attribute must be a valid address.",
          rule: (val: string, validator: any): boolean => {
            return validator?.helpers?.testRegex(
              val,
              /^[a-zA-Z0-9\s,'-.#:]*$/i
            );
          },
        },
        noSpecialChar: {
          message: "The :attribute must be without special characters.",
          rule: (val: string, validator: any) => {
            return validator?.helpers?.testRegex(
              val,
              /^[a-zA-Z0-9\s,'-.!:]*$/i
            );
          },
        },
      },
    });
    this.cardFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  };

  public componentDidMount = async () => {
    const {
      order,
      appUserDetails,
      fetchUndeliverablePostalCodes,
      organizations,
      getOrganizationSettings,
      validateMenuCategoryItems,
      getOrganizationOrdersOpenSchedule,
    } = this.props;

    this.getOrganizationAddress();
    const response = await getOrganizationSettings();
    this.setState({
      isDiscounts: response?.data?.discounts,
      pickupWindow: response?.data?.pickupWindow || 0,
      deliveryWindow: response?.data?.deliveryWindow || 0,
    });

    if (order.orderItems && order.orderItems.length > 0) {
      const menuCategoryItems = order.orderItems.map(
        (item: any) => item?.menuCategoryItem?.id
      );

      const response = await validateMenuCategoryItems({
        organizationId: organizations?.organization?.id,
        menuCategoryItems: menuCategoryItems,
      });

      if (
        response?.data?.menuCategoryItems &&
        response?.data?.menuCategoryItems.length > 0
      ) {
        const invalidItemsIds = response?.data?.menuCategoryItems;

        for (const invalidItemId of invalidItemsIds) {
          const invalidItem = order.orderItems.find(
            (item: any) => item?.menuCategoryItem?.id === invalidItemId
          );

          if (invalidItem) {
            const itemName =
              invalidItem.name ||
              invalidItem.menuCategoryItem.menuItem.name ||
              "Unknown Item";
            this.setState({
              orderCreateError: true,
              orderCreateErrorMessage: `Item ${itemName} is no longer available`,
            });

            await this.orderRemoveItem(invalidItem.id);
          }
        }
      }
    }

    if (appUserDetails) {
      this.setState({ appUserState: appUserDetails });
    }

    if (order?.coupon?.code) {
      this.setState({ couponCode: order.coupon.code });
    }

    if (this.props.isGuestLogin && !this.props.utility.openSignInModel) {
      this.props.handleClickOpenSignInModel();
    }

    this.getCalculatedEstimatedTimeFromAPI(this.state.orderType);

    const openHoursResponse = await getOrganizationOrdersOpenSchedule(this.state.orderType);
    const isScheduleNotFound = !openHoursResponse?.data;
    if (isScheduleNotFound) {
      await getOrganizationOrdersOpenSchedule("Base");
      this.getCalculatedEstimatedTimeFromAPI("Base");
      this.setState({ isOpenScheduleReturnedMessage: true });
    }
    this.determineShowStorePolicy(isScheduleNotFound);

    this.setState({ orderSaveRequest: true });

    window.addEventListener("message", this.handleMessage);
    this.calculateEstimatedTimeTimer = setInterval(
      () => this.calculateEstimatedTime(),
      1 * 60 * 1000
    );

    this.updateUserType();
    const addressRes: any = await this.props.addressesGet();
    if (addressRes?.status === 200) {
      this.setState({
        savedAddresses: addressRes?.data,
        selectedAddressId:
          addressRes?.data?.length > 0
            ? addressRes?.data?.find((addrs: any) => addrs.isDefault === true)
                ?.id ?? addressRes.data[0]?.id
            : "",
      });
    }
    if (typeof addressRes === "string") {
      this.setState({ savedAddresses: [] });
      Auth0WithOutRedirect.show();
    }
    fetchUndeliverablePostalCodes().then((res: any) => {
      if (res?.status === 200) {
        this.setState({
          undeliverablePostalCodes: res?.data?.postalCodes,
          undeliverableDistances: res?.data?.distances,
          undeliverableTravelTime: res?.data?.driveDurations,
        });
      }
      if (typeof res === "string") {
        this.setState({
          undeliverablePostalCodes: [],
          undeliverableDistances: [],
          undeliverableTravelTime: [],
        });
      }
    });
    this.props.getPickListOptionsFromAPI("Category").then((res: any) => {
      this.setState({
        pickListCategoryOptions: res?.data || [],
      });
    });
    this.props.getPickListOptionsFromAPI("Theme").then((res: any) => {
      this.setState({
        pickListThemeOptions: res?.data || [],
      });
    });
    this.props.getPickListOptionsFromAPI("Operation").then((res: any) => {
      this.setState({
        pickListOperationOptions: res?.data || [],
      });
    });
    this.props
      .getPickLists(organizations?.organization?.id)
      .then((res: any) => {
        this.setState({
          pickListByOrganization: res?.data || [],
        });
      });

    await this.loadGoogleMapsAPI();

    if (this.state.orderType === "Delivery") {
      this.getCalculatedDistanceAndTravelTime();
    }
    this.setState({ detailsExpended: this.checkRequiredFields() });
  };

  private loadGoogleMapsAPI = (): Promise<void> => {
    const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
    return new Promise((resolve, reject) => {
      if (window.google) {
        resolve(); // Google Maps API is already loaded
      } else {
        const existingScript = document.getElementById("googleMaps");
        if (!existingScript) {
          const script = document.createElement("script");
          script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`;
          script.id = "googleMaps";
          document.body.appendChild(script);

          script.onload = () => {
            resolve();
          };
          script.onerror = (error) => {
            reject(error);
          };
        } else {
          existingScript.onload = () => resolve();
        }
      }
    });
  };

  private updateUserType() {
    const { oidc } = this.props;

    this.setState({
      guest:
        oidc?.user?.profile?.preferred_username === "GuestUser" &&
        oidc?.user?.profile?.email === "support@horizonbusinessservices.com",
    });
  }

  public componentWillUnmount() {
    // Unlock zoom if we leave the page with the payment dialog still open
    this.setPaymentZoomLock(false);
    this.activePayment = null;
    window.removeEventListener("message", this.handleMessage);
    clearInterval(this.calculateEstimatedTimeTimer);
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  private getCalculatedPaymentsFromAPI() {
    const { discount } = this.state;
    if (this.props.order?.orderItems?.length === 0) {
      this.setState({
        totalTax: 0,
        total: 0,
        subtotal: 0,
        serviceChargeTotal: 0,
        gratuityTotal: 0,
        deliveryFee: 0,
      });
    } else {
      this.setState({ calculatePaymentLoading: true });
      const ordItems = this.props.order?.orderItems?.map((item: any) => {
        return {
          menuCategoryItemId: item?.menuCategoryItemId,
          quantity: item?.quantity,
          orderItemModifiers: transformArrayFromModifiers(
            item?.orderItemModifiers
          ),
          notes: item?.notes,
        };
      });
      const body = {
        orderItems: ordItems,
        discountName: discount,
        orderType: this.state.orderType,
        additionalChargeSources:
          this.state.orderType === "Delivery"
            ? {
              deliveryPostalCode: this.getOrderDeliveryAddress()?.postalCode,
              estimatedDriveDuration: this.state.travelTimeInMins,
              distanceInMiles: this.state.distanceInMiles,
            }
            : {},
        orderRevenueTypeCounty: this.getCounty(),
      };
      this.props.fetchCalculatedPayment(body).then((res: any) => {
        this.setState(
          {
            calculatePaymentLoading: false,
            totalTax: res?.data?.taxTotal,
            total: res?.data?.total,
            subtotal: res?.data?.subTotal,
            serviceChargeTotal: res?.data?.serviceCharge,
            gratuityTotal: res?.data?.gratuity,
            deliveryFee: res?.data?.deliveryFee,
            discountTotal: res?.data?.discountTotal,
          },
          () => {
            this.callSkipifyEndpoint();
          }
        );
      });
    }
  }

  private getCalculatedEstimatedTimeFromAPI = (orderType?: string) => {
  const scheduleType = orderType || this.state.orderType;

    if (this.props.order?.orderItems?.length === 0) {
      this.setState({
        laterSchedDate: new Date(),
        minimumPickupDate: new Date(),
        eventDate: new Date(),
        eventStart: new Date(),
        pickupDeliveryTime: new Date(),
        eventEnd: new Date(new Date().getTime() + 15 * 60000),
        calculatedEstimatedTimeFromAPI: null,
      });
    } else {
      this.setState({ calculateEstimatedTimeLoading: true });
      const orderItems = this.props.order?.orderItems?.map((item: any) => {
        return {
          menuCategoryItemId: item?.menuCategoryItemId,
          quantity: item?.quantity,
        };
      });
      this.props
        .fetchCalculatedEstimatedTime({ orderItems, scheduleType })
        .then((res: any) => {
          this.setState(
            {
              laterSchedDate: moment(
                this.getNextAvailableTime(
                  res?.data,
                  this.props.organizationOrdersOpenSchedule,
                  this.props.organizationSettings
                )
              ).toDate(),
              minimumPickupDate: moment(res?.data).toDate(),
              backecndEstimatedTime: moment(res?.data).toDate(),
              pickupDeliveryTime: moment(
                this.getNextAvailableTime(
                  res?.data,
                  this.props.organizationOrdersOpenSchedule,
                  this.props.organizationSettings
                )
              ).toDate(),
              eventDate: moment(
                this.getNextAvailableTime(
                  res?.data,
                  this.props.organizationOrdersOpenSchedule,
                  this.props.organizationSettings
                )
              ).toDate(),
              eventStart: moment(res?.data).toDate(),
              eventEnd: new Date(
                moment(res?.data).toDate().getTime() + 15 * 60000
              ),
              calculatedEstimatedTimeFromAPI: moment(res?.data).format(),
            },
            () => {
              this.setState({
                calculateEstimatedTimeLoading: false,
              });
            }
          );
        });
    }
  }

  private getCalculatedDistanceAndTravelTime() {
    const {
      orderType,
      address1,
      city,
      stateProvince,
      postalCode,
      savedAddresses,
      selectedAddressId,
    } = this.state;

    const { organization } = this.props;

    const selectedAddress = savedAddresses?.find(
      (address: any) => address?.id === selectedAddressId
    );

    const destinationAddress = selectedAddress || {
      address1,
      city,
      stateProvince,
      postalCode,
    };

    if (orderType === "Delivery" && window.google) {
      const service = new google.maps.DistanceMatrixService();

      const request = {
        origins: [
          `${organization?.address1}, ${
            organization?.address2 ? `${organization.address2}, ` : ""
          }${organization?.city}, ${organization?.stateProvince} ${
            organization?.postalCode
          }`,
        ],
        destinations: [
          `${destinationAddress?.address1}, ${destinationAddress?.city}, ${
            destinationAddress?.stateProvince
          } ${destinationAddress?.postalCode}`,
        ],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC,
      };

      service
        .getDistanceMatrix(request)
        .then((response: any) => {
          const distance = response.rows[0].elements[0].distance.value;
          const distanceInMiles = distance * 0.000621371;

          const duration = response.rows[0].elements[0].duration.value;
          const durationInMins = duration / 60;

          this.setState(
            {
              distanceInMiles: Math.round(distanceInMiles),
              travelTimeInMins: Math.round(durationInMins),
            },
            () => {
              this.getCalculatedPaymentsFromAPI();
            }
          );
        })
        .catch(() => {
          this.setState(
            {
              distanceInMiles: 0,
              travelTimeInMins: 0,
            },
            () => {
              this.getCalculatedPaymentsFromAPI();
            }
          );
        });
    } else {
      this.setState(
        {
          distanceInMiles: 0,
          travelTimeInMins: 0,
        },
        () => {
          this.getCalculatedPaymentsFromAPI();
        }
      );
    }
  }

  public async componentDidUpdate(
    prevProps: IPageProps,
    prevState: IPageState
  ) {
    // Lock iOS auto-zoom while the payment dialog is open
    if (prevState.openPayMethodModel !== this.state.openPayMethodModel) {
      this.setPaymentZoomLock(this.state.openPayMethodModel);
    }
    if (this.state.orderType !== prevState.orderType) {
      this.setState({ saveAddress: false });
      if (
        this.state.orderType === "Delivery" ||
        this.state.orderType === "Event"
      ) {
      }
    }
    if (
      prevProps.pickListByOrganization !== this.props.pickListByOrganization
    ) {
      const hasAnyRequiredField = this.props.pickListByOrganization?.some(
        (item: any) =>
          item?.isRequiredForEvent ||
          item?.isRequiredForDelivery ||
          item?.isRequiredForPickup
      );

      this.setState({ detailsExpended: hasAnyRequiredField });
    }

    if (this.state.postalCode !== prevState.postalCode) {
      this.getCalculatedPaymentsFromAPI();
    }

    if (this.state.address1 !== prevState.address1) {
      this.getCalculatedDistanceAndTravelTime();
    }

    if (this.state.selectedAddressId !== prevState.selectedAddressId) {
      this.getCalculatedDistanceAndTravelTime();
    }
    if (this.props.order !== prevProps.order) {
      this.getCalculatedDistanceAndTravelTime();
    }
    // if (
    //   this.props.organizationOrdersOpenSchedule !==
    //   prevProps.organizationOrdersOpenSchedule
    // ) {
    //   this.getCalculatedEstimatedTimeFromAPI();
    // }
    if (this.props.organizationSettings !== prevProps.organizationSettings) {
      if (this.props.organizationSettings?.defaultOrderType === "Delivery") {
        this.setState({ orderType: "Delivery" });
      } else if (
        this.props.organizationSettings?.defaultOrderType === "Event"
      ) {
        this.setState({ orderType: "Event" });
      } else {
        this.setState({ orderType: "Pickup" });
      }
    }
    const { customer, settings, order, userPersonalDetails } = this.props;
    const { estimatedReadyTimeMax, orderSaveRequest, throttlingBuffer } =
      this.state;

    if (
      prevProps.order?.coupon?.code !== order?.coupon?.code &&
      !!order?.coupon?.code
    ) {
      this.setState({ couponCode: order.coupon.code });
    }

    if (
      orderSaveRequest &&
      !!this.props.order.id &&
      this.state.orderType !== null
    ) {
      await this.completeOrderSaveRequest();
    }

    if (
      prevState.estimatedReadyTimeMax === undefined &&
      estimatedReadyTimeMax
    ) {
      this.setState({ selectedDate: estimatedReadyTimeMax });
    }

    if (prevProps.customer !== customer) {
      this.checkUserProfile();
    }

    if (prevProps.settings !== settings) {
      const companyLogo =
        this.props.organizationSettings?.grazeLogo ||
        "/static/images/logos/defaultLogo.svg";
      const orderMinimum = settings.GRAZE_ORDER_MINIMUM
        ? parseFloat(settings.GRAZE_ORDER_MINIMUM.value.replace(",", "."))
        : 0;
      const orderMinimumMessage = settings.GRAZE_ORDER_MINIMUM_MESSAGE
        ? settings.GRAZE_ORDER_MINIMUM_MESSAGE.value
        : "";
      const onlineOrderClosedMessage =
        settings.GRAZE_ONLINE_ORDERS_CLOSED_MESSAGE
          ? settings.GRAZE_ONLINE_ORDERS_CLOSED_MESSAGE.value
          : "";
      const undeliverableZoneMessage = settings.GRAZE_ORDER_UNDELIVERABLE_ZONE
        ? settings.GRAZE_ORDER_UNDELIVERABLE_ZONE.value
        : "";
      const throttlingOverloadMessage = settings.GRAZE_ORDER_THROTTLING_MESSAGE
        ? settings.GRAZE_ORDER_THROTTLING_MESSAGE.value
        : "";
      const showAsap = settings.GRAZE_CHECKOUT_ASAP
        ? settings.GRAZE_CHECKOUT_ASAP.value === false
        : true;
      const onlineOrderTermsMessage = settings.GRAZE_ORDER_TERMS_CUSTOM_MESSAGE
        ? settings.GRAZE_ORDER_TERMS_CUSTOM_MESSAGE.value
        : "";

      this.setState({
        companyLogo,
        showAsap,
        scheduleForLater: true,
        orderMinimum,
        orderMinimumMessage,
        onlineOrderClosedMessage,
        undeliverableZoneMessage,
        throttlingOverloadMessage,
        onlineOrderTermsMessage,
        firstName: this.state.firstName || userPersonalDetails?.firstName || "",
        lastName: this.state.lastName || userPersonalDetails?.lastName || "",
        phoneNumber:
          this.state.phoneNumber || userPersonalDetails?.phoneNumber || "",
        email: this.state.email || userPersonalDetails?.emailAddress || "",
      });
    }

    if (
      throttlingBuffer &&
      throttlingBuffer > 0 &&
      prevState.throttlingBuffer !== throttlingBuffer
    ) {
      this.calculateEstimatedTime();
    }

    if (
      prevProps.oidc?.user?.profile?.email !==
      this.props.oidc?.user?.profile?.email
    ) {
      this.updateUserType();
    }
    if (
      prevProps.organizationSettings !== this.props.organizationSettings &&
      prevProps.organizationSettings?.useSkipify !==
      this.props.organizationSettings?.useSkipify
    ) {
      if (this.props.organizationSettings?.useSkipify) {
        this.callSkipifyEndpoint();
      }
    }
    if (!this.state.creatingOrderWithSkipify && this.state.skipifyClose) {
      if (this.state.skipifySuccessOrderID) {
        this.props.router?.navigate(
          `/order-confirmed/${this.state.skipifySuccessOrderID}`
        );
      }
    }
    if (this.state.skipifyPopupOpen && !prevState.skipifyPopupOpen) {
      // If skipifyPopupOpen changed to true, start a 5-minute timer
      this.timer = setTimeout(() => {
        window.location.reload();
      }, 300000);
    } else if (!this.state.skipifyPopupOpen && prevState.skipifyPopupOpen) {
      // If skipifyPopupOpen changed to false, clear the timer
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    }

 const pickupTime = localStorage.getItem("requestedPickupDateTime");

 if (prevState.laterSchedDate !== this.state.laterSchedDate && !this.state.timeUpdatedMessage) {
      const { organizationOrdersOpenSchedule, organizationSettings } =
        this.props;
      const formattedHolidays = getFormattedHolidays(organizationSettings);

      if (organizationOrdersOpenSchedule && this.state.laterSchedDate) {
        const openHoursList = getTodayOpenHours(
          organizationOrdersOpenSchedule,
          this.state.laterSchedDate,
          formattedHolidays
        );

        if (openHoursList) {
              const backendDate = this.state.laterSchedDate;
              const firstDate = moment(this.state.laterSchedDate).format(
                "MM-DD-YYYY"
              );
              const todayDate = moment().format("MM-DD-YYYY");
              const secondDate = moment(backendDate).format("MM-DD-YYYY");

              if (
                (
                  this.props.organizationSettings.ordersAdvanceNoticeHours > 0 ||
                  this.props.organizationSettings.ordersAdvanceNoticeHoursPickUp > 0 ||
                  this.props.organizationSettings.ordersAdvanceNoticeHoursDelivery > 0 ||
                  this.props.organizationSettings.ordersAdvanceNoticeHoursEvent > 0
                ) && firstDate === secondDate
              ) {
                const minusHoursFromThis = this.state.backecndEstimatedTime;
                let updatedOpenFrom = openHoursList.openFrom;
                if (openHoursList.openFrom < minusHoursFromThis) {
                  updatedOpenFrom =
                    roundToNextFifteenMinutes(minusHoursFromThis);
                }

                if(pickupTime && new Date(pickupTime) > new Date()){
                   this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  requestedPickupAndDeliveryTime: new Date(pickupTime),
                });
                } else {
                   this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  requestedPickupAndDeliveryTime: updatedOpenFrom,
                });
                }
              } else if (firstDate === todayDate) {
                const now = new Date();
                const roundedCurrentTime = roundToNextFifteenMinutes(now);
                let updatedOpenFrom = openHoursList.openFrom;

                if (openHoursList.openFrom < roundedCurrentTime) {
                  updatedOpenFrom = roundedCurrentTime;
                }

                 if(pickupTime && new Date(pickupTime) > new Date()){
                   this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  requestedPickupAndDeliveryTime: new Date(pickupTime),
                });
                } else {
                   this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  requestedPickupAndDeliveryTime: updatedOpenFrom,
                });
                }
              } else {
                if(pickupTime && new Date(pickupTime) > new Date()){
                this.setState({
                  openHoursList,
                  requestedPickupAndDeliveryTime: new Date(pickupTime),
                });
                } else {
                this.setState({
                  openHoursList,
                  requestedPickupAndDeliveryTime: openHoursList.openFrom,
                });
                }
              }
        }
      }
    }

  const eventEndDateTime = localStorage.getItem("eventEndDateTime");

    if (prevState.eventDate !== this.state.eventDate && !this.state.eventTimeUpdatedMessage) {

      const { organizationOrdersOpenSchedule, organizationSettings } =
        this.props;
      const formattedHolidays = getFormattedHolidays(organizationSettings);

      if (organizationOrdersOpenSchedule && this.state.eventDate) {
        const openHoursList = getTodayOpenHours(
          organizationOrdersOpenSchedule,
          this.state.eventDate,
          formattedHolidays
        );

        if (openHoursList) {
              const backendDate = this.state.laterSchedDate;
              const firstDate = moment(this.state.laterSchedDate).format("MM-DD-YYYY");
              const secondDate = moment(backendDate).format("MM-DD-YYYY");
              const todayDate = moment().format("MM-DD-YYYY");

              const isPickupTimeValid = pickupTime && new Date(pickupTime) > new Date();
              const isEventEndTimeValid = eventEndDateTime && new Date(eventEndDateTime) > new Date();

               if (
                (
                  this.props.organizationSettings.ordersAdvanceNoticeHours > 0 ||
                  this.props.organizationSettings.ordersAdvanceNoticeHoursPickUp > 0 ||
                  this.props.organizationSettings.ordersAdvanceNoticeHoursDelivery > 0 ||
                  this.props.organizationSettings.ordersAdvanceNoticeHoursEvent > 0
                ) && firstDate === secondDate
              ) {
                const minusHoursFromThis = this.state.backecndEstimatedTime;
                let updatedOpenFrom = openHoursList.openFrom;

                if (openHoursList.openFrom < minusHoursFromThis) {
                  updatedOpenFrom =
                    roundToNextFifteenMinutes(minusHoursFromThis);
                }

                if(isPickupTimeValid || isEventEndTimeValid) {
                 this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  eventFieldStartTime: pickupTime ? new Date(pickupTime) : updatedOpenFrom,
                  eventFieldEndTime: getEventEndTime(pickupTime ? new Date(pickupTime) : updatedOpenFrom ,  isEventEndTimeValid ? new Date(eventEndDateTime) : openHoursList.openTo) ,
                });
                }
                else {
                this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  eventFieldStartTime: updatedOpenFrom,
                  eventFieldEndTime: getEventEndTime(updatedOpenFrom, openHoursList.openTo),
                });
                }
              } else if (firstDate === todayDate) {
                const now = new Date();
                const roundedCurrentTime = roundToNextFifteenMinutes(now);
                let updatedOpenFrom = openHoursList.openFrom;

                if (openHoursList.openFrom < roundedCurrentTime) {
                  updatedOpenFrom = roundedCurrentTime;
                }

                if(isPickupTimeValid || isEventEndTimeValid) {
                 this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  eventFieldStartTime: pickupTime ? new Date(pickupTime) : updatedOpenFrom,
                  eventFieldEndTime: getEventEndTime(pickupTime ? new Date(pickupTime) : updatedOpenFrom, isEventEndTimeValid ? new Date(eventEndDateTime) : openHoursList.openTo)  ,
                });
                }
                else {
                this.setState({
                  openHoursList: {
                    ...openHoursList,
                    openFrom: updatedOpenFrom,
                  },
                  eventFieldStartTime: updatedOpenFrom,
                  eventFieldEndTime: getEventEndTime(updatedOpenFrom, openHoursList.openTo),
                });
                }
              } else {
               if(isPickupTimeValid || isEventEndTimeValid) {
                 this.setState({
                  openHoursList,
                  eventFieldStartTime: pickupTime ? new Date(pickupTime) : openHoursList.openFrom,
                  eventFieldEndTime: getEventEndTime(pickupTime ? new Date(pickupTime) : openHoursList.openFrom, isEventEndTimeValid ? new Date(eventEndDateTime) : openHoursList.openTo)  ,
                });
                }
                else {
                this.setState({
                  openHoursList,
                  eventFieldStartTime: openHoursList.openFrom,
                  eventFieldEndTime: getEventEndTime(openHoursList.openFrom, openHoursList.openTo),
                });
                }
              }
        }
      }
    }
  }

  public getNextAvailableTime(
    laterSchedDate: any,
    organizationOrdersOpenSchedule: any,
    organizationOrders: any
  ) {
      if (!organizationOrdersOpenSchedule || !organizationOrders) {
        return laterSchedDate;
      }

      if (!organizationOrders.ordersHolidays) {
        organizationOrders = { ...organizationOrders, ordersHolidays: [] };
      }

    let nextAvailableDate = moment(laterSchedDate);
    let attempts = 0;
    let isFirstDay = true;

    while (true) {
      const dayOfWeek = nextAvailableDate.format("dddd").toLowerCase();
      const daySettings = organizationOrdersOpenSchedule[dayOfWeek];

      if (
        organizationOrders.ordersHolidays.find((holiday: any) =>
          moment(holiday.holidayDate).isSame(nextAvailableDate, "day")
        )
      ) {
        nextAvailableDate.add(1, "days").startOf("day");
        attempts++;
        if (attempts > 7) {
          return laterSchedDate;
        }
        continue;
      }

      if (!daySettings.closedAllDay) {
        const openingTime = moment(
          new Date(
            `${new Date().toISOString().split("T")[0]}T${daySettings?.openFrom
            }Z`
          )
        );
        const closingTime = moment(
          new Date(
            `${new Date().toISOString().split("T")[0]}T${daySettings?.openTo}Z`
          )
        );

        if (closingTime.hour() < openingTime.hour()) {
          closingTime.add(1, "days");
        }

        openingTime
          .year(nextAvailableDate.year())
          .month(nextAvailableDate.month())
          .date(nextAvailableDate.date());
        closingTime
          .year(nextAvailableDate.year())
          .month(nextAvailableDate.month())
          .date(nextAvailableDate.date());

        if (isFirstDay) {
          if (
            nextAvailableDate.isBetween(openingTime, closingTime, null, "[)")
          ) {
            return nextAvailableDate.format("YYYY-MM-DDTHH:mm:ss");
          } else if (nextAvailableDate.isBefore(openingTime)) {
            return roundToNext15Min(openingTime).format("YYYY-MM-DDTHH:mm:ss");
          }
          isFirstDay = false;
        } else {
          return roundToNext15Min(openingTime).format("YYYY-MM-DDTHH:mm:ss");
        }
      }

      nextAvailableDate.add(1, "days").startOf("day");
      attempts++;
      if (attempts > 7) {
        return laterSchedDate;
      }
    }
  }

  private payDisabled = () => {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      address1,
      stateProvince,
      city,
      orderType,
    } = this.state;
    if (orderType === "Delivery") {
      if (
        (!address1 || !city || !stateProvince) &&
        this.state.selectedAddressId === ""
      ) {
        return true;
      }
    }
    if (
      firstName === "" ||
      lastName === "" ||
      phoneNumber === "" ||
      email === ""
    ) {
      return true;
    }
    return false;
  };

  private postCartToSkipify = (
    body: any
  ): Promise<AxiosResponse | AxiosError> => {
    const grazeApiKey = process.env.REACT_APP_GRAZE_API_KEY;
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_PAYMENT_URL}/skipify/cart`, body, {
          headers: {
            "Graze-Api-Key": grazeApiKey,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse) => {
          resolve(res);
        })
        .catch((err: AxiosError) => {
          reject(err);
        });
    });
  };

  private getCartPaymentDetailsSkipify = (): Promise<
    AxiosResponse | AxiosError
  > => {
    const grazeApiKey = process.env.REACT_APP_GRAZE_API_KEY;
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_PAYMENT_URL}/skipify/cart/${this.state.skipifyGuid}`,
          {
            headers: {
              "Graze-Api-Key": grazeApiKey,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res: AxiosResponse) => {
          resolve(res);
        })
        .catch((err: AxiosError) => {
          reject(err);
        });
    });
  };

  private callSkipifyEndpoint = () => {
    if (this.props.organizationSettings?.useSkipify) {
      this.setState({ skipifyPayButtonLoading: true });
      const cardRefId = uuidv4();
      const skipifyCartItems = this.props.order.orderItems.map((item: any) => {
        const calcPrice =
          item?.price +
          getReorderModifiersPrice(item?.orderItemModifiers || []);
        return {
          itemId: `${item?.id}`,
          title: item?.name,
          quantity: item?.quantity,
          productType: "physical",
          price: {
            value: Math.round(calcPrice * 100),
            uom: "USD",
          },
          image: {
            url: item?.menuCategoryItem?.imageUrl,
            alt: "",
          },
        };
      });
      if (skipifyCartItems?.length > 0) {
        const skipifyPayload = {
          id: uuidv4(),
          skipifyMerchantId: this.props.organizationSettings.skipifyMerchantID,
          cartReferenceId: cardRefId,
          cartPayload: JSON.stringify([
            ...skipifyCartItems,
            {
              itemId: "00000",
              title: "Service Charge",
              quantity: 1,
              productType: "service",
              price: {
                value: Math.round(this.state.serviceChargeTotal * 100),
                uom: "USD",
              },
              image: {
                url: "",
                alt: "",
              },
            },
            {
              itemId: "00000",
              title: "Gratuity",
              quantity: 1,
              productType: "service",
              price: {
                value: Math.round(this.state.gratuityTotal * 100),
                uom: "USD",
              },
              image: {
                url: "",
                alt: "",
              },
            },
             {
              itemId: "00000",
              title: "Delivery Fee",
              quantity: 1,
              productType: "service",
              price: {
                value: Math.round(this.state.deliveryFee * 100),
                uom: "USD",
              },
              image: {
                url: "",
                alt: "",
              },
            },
          ]),
          discountAmount: Math.round(this.state.discountTotal * 100),
          taxAmount: Math.round(this.state.totalTax * 100),
          currency: "USD",
        };
        this.postCartToSkipify(skipifyPayload).then((res) => {
          this.setState({
            skipifyGuid: cardRefId,
            skipifyPayButtonLoading: false,
          });
        });
      }
    }
  };

  public render() {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      addressName,
      postalCode,
      city,
      saveAddress,
      stateProvince,
      notes,
      openPayMethodModel,
      openOpenHoursModel,
      openPolicyModel,
      selectedDateError,
      orderType,
      onlineOrderClosedMessage,
      undeliverableZoneMessage,
      onlineOrderEnabled,
      throttlingBuffer,
      throttlingOverloadMessage,
      estimatedReadyTimeMax,
      companyName,
      eventName,
      eventDate,
      eventEnd,
      expectedGuestCount,
      eventNotes,
      detailsExpended,
      pickListByOrganization,
      onlineOrderTermsMessage,
      qtyError,
      paymentPayload,
      laterSchedDate,
      minimumPickupDate,
      calculatePaymentLoading,
      totalTax,
      total,
      loadPaymentUrl,
      subtotal,
      serviceChargeTotal,
    } = this.state;
    const {
      classes,
      order,
      organizationSettings,
      organizationOrdersOpenSchedule,
      organization,
    } = this.props;
    this.validator.purgeFields();
    this.cardFormValidator.purgeFields();
    const isOrderEmpty =
      !order || !order.orderItems || order.orderItems.length === 0;

      const minimumTotal = orderType === "Delivery"
      ? organizationSettings?.deliveryMinimumTotal
      : orderType === "Event"
      ? organizationSettings?.eventMinimumTotal
      : organizationSettings?.ordersMinimumTotal;

    const orderMinimumNotMet =
      subtotal + serviceChargeTotal + totalTax < minimumTotal;

    const undeliverableZone =
      orderType === "Delivery" &&
      !!order.orderDelivery &&
      order.orderDelivery.deliveryCharge === null;

    const schedule = getWeeklySchedule(organizationOrdersOpenSchedule);
    const formattedHolidays = getFormattedHolidays(organizationSettings);

    const isKitchenClosed = () => {
    const start =
      moment(eventDate).format("YYYY-MM-DD") +
      moment(this.state.eventFieldStartTime).utc().format("THH:mm:ss.SSS[Z]");

    let openFrom;
    let openTo;
    let scheduleTime;

    if (!organizationSettings?.enableOrders) {
      return true;
    } else {
      const dateToCheck =
        orderType === "Event" ? start : this.state.laterSchedDate;
      const formattedDate = moment(dateToCheck).format("YYYY-MM-DD");

      const matchedHoliday = organizationSettings?.ordersHolidays?.find(
        (holiday: any) => {
          const holidayDate = moment(holiday.holidayDate).format("YYYY-MM-DD");
          return holidayDate === formattedDate;
        }
      );

        const pickupDateTime =
        orderType === "Event"
          ? new Date(start)
          : new Date(this.state.requestedPickupAndDeliveryTime);

      const orgUtcOffset = organizationSettings?.utcOffset ?? -(pickupDateTime.getTimezoneOffset() / 60);

      const getScheduleTime = (dateTime: Date | string) =>
        moment(dateTime).utcOffset(orgUtcOffset * 60)

      if (matchedHoliday) {
        if (matchedHoliday.closedAllDay) {
          return true;
        }

        if (matchedHoliday.openAllDay) {
          return false;
        }

        openFrom = matchedHoliday.openFrom;
        openTo = matchedHoliday.openTo;
        scheduleTime = moment(getScheduleTime(
          orderType === "Event"
            ? start
            : this.state.requestedPickupAndDeliveryTime
        )).format("HH:mm:ss");
      } else {
        const daySettings = organizationOrdersOpenSchedule
          ? organizationOrdersOpenSchedule[
              getDay(orderType === "Event" ? start : this.state.laterSchedDate)
            ]
          : null;

        if (daySettings?.closedAllDay) {
          return true;
        }

      openFrom = daySettings?.openFrom;
      openTo = daySettings?.openTo;
      // Open hours are UTC times shown with today's offset (see getWeeklySchedule and the API's
      // GetRequestedLocalDateTimeWithSeasonAlignment), so shift the pickup time by the DST
      // difference between today and the pickup date before comparing.
      const dstShiftMinutes = new Date().getTimezoneOffset() - pickupDateTime.getTimezoneOffset();

      scheduleTime = moment(getScheduleTime(pickupDateTime)).utc().add(dstShiftMinutes, 'minutes').format("HH:mm:ss");
      }

      return !checkIfOpenUsingHoursandScheduledTime(
        openFrom,
        openTo,
        scheduleTime
      );
    }
  };

    const eventAdditionalDetails = pickListByOrganization?.some(
      (item: any) => item?.isSelectedForEvent
    );

    const pickupOverride = pickListByOrganization?.filter(
      (item: any) => item.isSelectedForPickup
    );
    const customName = pickupOverride?.map((item: any) => item?.customName);

    const deliveryOverrides = pickListByOrganization?.filter(
      (item: any) => item?.isSelectedForDelivery
    );
    const customNames = deliveryOverrides?.map((item: any) => item?.customName);
    const showPickupDeliveryAdditionalDetails =
      orderType === "Delivery"
        ? deliveryOverrides?.some((item: any) => item?.isSelectedForDelivery)
        : orderType === "Pickup" && pickupOverride?.some((item: any) => item?.isSelectedForPickup);

    const EventOverrides = pickListByOrganization?.filter(
      (item: any) => item?.isSelectedForEvent
    );
    const eventCustomNames = EventOverrides?.map(
      (item: any) => item?.customName
    );

    return (
      <Auth0Provider>
        <div className={classes.root}>
          {organizationSettings && this.state.undeliverablePostalCodes ? (
            <Grid container={true} spacing={3}>
              <Grid item={true} xs={12} sm={7} className={classes.gridContent}>
                <Grid container={true} spacing={4} sx={{ marginTop: 0 }}>
                  <Container component="main" disableGutters={false} sx={{ width: { xs: "calc(100vw - 10px)", sm: "100%"  } }}>
                    <Box>
                       {this.renderOnlineOrderClosedMessage(onlineOrderEnabled, onlineOrderClosedMessage)}
                        {this.renderUndeliverableZoneMessage(undeliverableZone, undeliverableZoneMessage)}
                        {this.renderThrottlingOverloadMessage(throttlingBuffer === -1, throttlingOverloadMessage)}
                        {this.renderOnlineOrderTermsMessage(onlineOrderClosedMessage, onlineOrderTermsMessage)}
                        {orderMinimumNotMet && (
                            <Stack
                                sx={{
                                    background: "#ffc700",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "10px",
                                }}
                            >
                                <Typography variant='caption'>{organizationSettings?.ordersMinimumMessage.replace('{orderMinimum}', `$${formatMoney(minimumTotal)}`)} <NavLink to="/">Continue Shopping</NavLink></Typography>
                            </Stack>
                        )}
                      <Box sx={{
                        marginTop: { xs: "5%", md: 0 },
                        '@media (max-width:412px)': {
                          marginTop: organizationSettings?.portraitIcon !== false
                              && isClosed(organizationSettings, organizationOrdersOpenSchedule)
                            ? '30%'
                            : '5%',
                        }, }}>
                        <Typography
                          gutterBottom={true}
                          mb={2}
                          mt={2}
                          sx={{ fontSize: { sm: "20px" }, fontWeight: 600 }}

                        >
                          Order Type
                        </Typography>
                      </Box>
                      <OrderTypeSelector
                        orderType={orderType}
                        organizationSettings={organizationSettings}
                        onOrderTypeChange={(type) => this.setOrderType(type)}
                      />
                      {orderType === "Event" ? (
                        <>
                          <ClientInformationForm
                            companyName={companyName}
                            firstName={firstName}
                            lastName={lastName}
                            email={email}
                            phoneNumber={phoneNumber}
                            onHandleChange={(e, fieldName) => this.onhandleChange(e, fieldName)}
                            handlePhone={this.handlePhone}
                            validator={this.validator}
                            formatPhoneNumberInput={formatPhoneNumberInput}
                            StyledTextField={StyledTextField}
                            classes={classes}
                          />
                          {orderType === "Event" && (
                            <EventInformationForm
                              eventName={eventName}
                              eventDate={eventDate}
                              expectedGuestCount={expectedGuestCount}
                              eventFieldStartTime={this.state.eventFieldStartTime}
                              eventFieldEndTime={this.state.eventFieldEndTime}
                              eventDateUpdatedMessage={this.state.eventDateUpdatedMessage}
                              eventTimeUpdatedMessage={this.state.eventTimeUpdatedMessage}
                              eventEnd={eventEnd}
                              selectedDateError={selectedDateError}
                              showGuestCountError={this.state.showGuestCountError}
                              guestCountError={this.state.guestCountError}
                              openHoursList={this.state.openHoursList}
                              organizationSettings={organizationSettings}
                              organizationOrdersOpenSchedule={organizationOrdersOpenSchedule}
                              minimumPickupDate={minimumPickupDate}
                              estimatedReadyTimeMax={estimatedReadyTimeMax}
                              classes={classes}
                              validator={this.validator}
                              onChange={this.onhandleChange}
                              onStateChange={(updates) => this.setState(updates)}
                              showStorePolicy={this.state.showStorePolicy}
                            />
                          )}
                          {eventAdditionalDetails && (
                            <Box mt={2}>
                              <AdditionalDetailsAccordion
                                customNames={eventCustomNames}
                                overrides={EventOverrides}
                                selectedNames={this.state.selectedNames}
                                detailsExpended={detailsExpended}
                                orderPickListOptions={this.state.orderPickListOptions}
                                organizationSettings={organizationSettings}
                                classes={classes}
                                isRequiredKey="isRequiredForEvent"
                                onChange={this.onhandleChange}
                                onToggle={() =>
                                  this.setState({
                                    detailsExpended: !detailsExpended,
                                  })
                                }
                                onStateChange={(updates) => this.setState(updates)}
                              />
                            </Box>
                          )}
                          {orderType === "Event" && (
                            <EventAddressSection
                              selectedAddressId={this.state.selectedAddressId}
                              savedAddresses={this.state.savedAddresses}
                              addressName={addressName}
                              address1={this.state.address1}
                              city={city}
                              stateProvince={stateProvince}
                              postalCode={postalCode}
                              organizationSettings={organizationSettings}
                              classes={classes}
                              onChange={this.onhandleChange}
                              onStateChange={(updates) => this.setState(updates)}
                            />
                          )}
                          {eventAdditionalDetails && (
                            <AdditionalDetailsAccordion
                              customNames={eventCustomNames}
                              overrides={EventOverrides}
                              selectedNames={this.state.selectedNames}
                              detailsExpended={detailsExpended}
                              orderType={this.state.orderType}
                              orderPickListOptions={this.state.orderPickListOptions}
                              organizationSettings={organizationSettings}
                              classes={classes}
                              isRequiredKey="isRequiredForEvent"
                              eventNotes={eventNotes}
                              validator={this.validator}
                              onChange={this.onhandleChange}
                              onToggle={() =>
                                this.setState({
                                  detailsExpended: !detailsExpended,
                                })
                              }
                              onStateChange={(updates) => this.setState(updates)}
                              notesOnly
                            />
                          )}
                        </>
                      ) : (
                        <>
                          {orderType === "Delivery" && (
                            <DeliveryAddressSection
                              selectedAddressId={this.state.selectedAddressId}
                              savedAddresses={this.state.savedAddresses}
                              addressName={addressName}
                              address1={this.state.address1}
                              city={city}
                              stateProvince={stateProvince}
                              postalCode={postalCode}
                              saveAddress={saveAddress}
                              isLoggedIn={this.props.isLoggedIn}
                              organizationSettings={organizationSettings}
                              classes={classes}
                              onChange={this.onhandleChange}
                              onStateChange={(updates) => this.setState(updates)}
                            />
                          )}
                          <PickupDeliveryTimeSelector
                            orderType={orderType}
                            organizationSettings={organizationSettings}
                            organizationOrdersOpenSchedule={organizationOrdersOpenSchedule}
                            minimumPickupDate={minimumPickupDate}
                            openHoursList={this.state.openHoursList}
                            scheduleForLater={this.state.scheduleForLater}
                            calculateEstimatedTimeLoading={this.state.calculateEstimatedTimeLoading}
                            laterSchedDate={this.state.laterSchedDate}
                            requestedPickupAndDeliveryTime={this.state.requestedPickupAndDeliveryTime}
                            classes={classes}
                            onStateChange={(updates) => this.setState(updates)} enableAsap={false}
                            showStorePolicy={this.state.showStorePolicy}
                            timeUpdatedMessage={this.state.timeUpdatedMessage}
                            dateUpdatedMessage={this.state.dateUpdatedMessage}
                            pickupWindowTime={this.state.pickupWindow}
                            deliveryWindowTime={this.state.deliveryWindow}
                          />
                          {organizationSettings?.enableGuestCount && (
                            <GuestCountSection
                              organizationSettings={organizationSettings}
                              expectedGuestCount={expectedGuestCount}
                              classes={classes}
                              validator={this.validator}
                              onChange={this.onhandleChange}
                            />
                          )}
                          <ContactInformationSection
                            firstName={firstName}
                            lastName={lastName}
                            email={email}
                            phoneNumber={phoneNumber}
                            classes={classes}
                            validator={this.validator}
                            onChange={this.onhandleChange}
                            handlePhone={this.handlePhone}
                          />
                          {showPickupDeliveryAdditionalDetails && (
                            <Box mt={2}>
                              <AdditionalDetailsAccordion
                                customNames={orderType === "Delivery" ? customNames : customName}
                                overrides={orderType === "Delivery" ? deliveryOverrides : pickupOverride}
                                selectedNames={this.state.selectedNames}
                                detailsExpended={detailsExpended}
                                orderPickListOptions={this.state.orderPickListOptions}
                                organizationSettings={organizationSettings}
                                classes={classes}
                                isRequiredKey={
                                  orderType === "Delivery" ? "isRequiredForDelivery" : "isRequiredForPickup"
                                }
                                onChange={this.onhandleChange}
                                onToggle={() =>
                                  this.setState({
                                    detailsExpended: !detailsExpended,
                                  })
                                }
                                onStateChange={(updates) => this.setState(updates)}
                              />
                            </Box>
                          )}
                        </>
                      )}
                    </Box>
                  </Container>
                  {orderType === "Delivery" && (
                    <OrderNotesSection
                      orderType="Delivery"
                      notes={notes}
                      customNames={customNames}
                      deliveryOverrides={deliveryOverrides}
                      pickupOverride={pickupOverride}
                      selectedNames={this.state.selectedNames}
                      detailsExpended={detailsExpended}
                      orderPickListOptions={this.state.orderPickListOptions}
                      organizationSettings={organizationSettings}
                      classes={classes}
                      validator={this.validator}
                      onChange={this.onhandleChange}
                      onStateChange={(updates) => this.setState(updates)}
                    />
                  )}
                  {orderType === "Pickup" && (
                    <OrderNotesSection
                      orderType="Pickup"
                      notes={notes}
                      customNames={customName}
                      deliveryOverrides={deliveryOverrides}
                      pickupOverride={pickupOverride}
                      selectedNames={this.state.selectedNames}
                      detailsExpended={detailsExpended}
                      orderPickListOptions={this.state.orderPickListOptions}
                      organizationSettings={organizationSettings}
                      classes={classes}
                      validator={this.validator}
                      onChange={this.onhandleChange}
                      onStateChange={(updates) => this.setState(updates)}
                    />
                  )}
                </Grid>
                <Hidden lgUp={true}>
                  <Grid item={true} xs={12} sm={12}>
                    <OrderSummaryMobile
                      subtotal={subtotal}
                      serviceChargeTotal={this.state.serviceChargeTotal}
                      gratuityTotal={this.state.gratuityTotal}
                      deliveryFee={this.state.deliveryFee}
                      total={total}
                      calculatePaymentLoading={calculatePaymentLoading}
                      orderType={orderType}
                      totalTax={this.state.totalTax} />
                  </Grid>
                  <Box
                    mt={3}
                    sx={{
                      display: "flex",
                      width: "100%",
                      flexDirection: "column",
                    }}
                  >
                    <>
                      {!organizationSettings?.useSkipify ? (
                        <>
                          {organizationSettings?.enablePayNow && (
                            <Grid item={true} xs={12} sm={12}>
                              <div
                                style={{
                                  textAlign: "center",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: "8px",
                                }}
                              >
                                <StyledPayButton
                                  variant="contained"
                                  color="layoutColor"
                                  disableElevation
                                  disabled={
                                    isKitchenClosed() ||
                                    isOrderEmpty ||
                                    this.state.creatingOrder ||
                                    this.payDisabled() ||
                                    orderMinimumNotMet ||
                                    loadPaymentUrl ||
                                    (this?.state?.orderType === "Pickup" &&
                                      customName?.some(
                                        (name: any, index: any) => {
                                          const matchingDelivery =
                                            pickupOverride.find((event: any) =>
                                              name === ""
                                                ? event.customName === ""
                                                : event.customName === name
                                            );
                                          const isRequired =
                                            matchingDelivery?.isRequiredForPickup ===
                                            true;
                                          const hasValue =
                                            this.state.selectedNames[index] &&
                                            this.state.selectedNames[index] !==
                                            "";
                                          return isRequired && !hasValue;
                                        }
                                      )) ||
                                    (this.state.orderType === "Delivery" &&
                                      customNames?.some(
                                        (name: any, index: any) => {
                                          const matchingDelivery =
                                            pickupOverride.find((event: any) =>
                                              name === ""
                                                ? event.customName === ""
                                                : event.customName === name
                                            );
                                          const isRequired =
                                            matchingDelivery?.isRequiredForDelivery ===
                                            true;
                                          const hasValue =
                                            this.state.selectedNames[index] &&
                                            this.state.selectedNames[index] !==
                                            "";
                                          return isRequired && !hasValue;
                                        }
                                      )) ||
                                    (this.state.orderType === "Event" &&
                                      eventCustomNames?.some(
                                        (name: any, index: any) => {
                                          const matchingDelivery =
                                            pickupOverride.find((event: any) =>
                                              name === ""
                                                ? event.customName === ""
                                                : event.customName === name
                                            );
                                          const isRequired =
                                            matchingDelivery?.isRequiredForEvent ===
                                            true;
                                          const hasValue =
                                            this.state.selectedNames[index] &&
                                            this.state.selectedNames[index] !==
                                            "";
                                          return isRequired && !hasValue;
                                        }
                                      ))
                                  }
                                  sx={{
                                    backgroundColor:
                                      organizationSettings?.layoutColor,
                                    "&.MuiButton-root:hover": {
                                      backgroundColor:
                                        organizationSettings?.layoutColor,
                                    },
                                  }}
                                  onClick={this.payNow}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: { xs: "16px" },
                                      fontWeight: 600,
                                      // color: '#000000'
                                    }}
                                  >
                                    Pay Now ${formatMoney(this.state.total)}
                                  </Typography>
                                </StyledPayButton>
                              </div>
                            </Grid>
                          )}
                        </>
                      ) : (
                        <>
                          {this.state.skipifyPayButtonLoading ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CircularProgress size={20} color="secondary" />
                              <p style={{ fontSize: 16, paddingLeft: "8px" }}>
                                Loading Skipify
                              </p>
                            </div>
                          ) : (
                            <>
                              {isKitchenClosed() ||
                                isOrderEmpty ||
                                this.state.creatingOrderWithSkipify ||
                                this.payDisabled() ||
                                orderMinimumNotMet ||
                                loadPaymentUrl ? (
                                <Grid item={true} xs={12} sm={12}>
                                  <div
                                    style={{
                                      textAlign: "center",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      margin: "8px",
                                    }}
                                  >
                                    <StyledPayButton
                                      variant="contained"
                                      color="layoutColor"
                                      disableElevation
                                      disabled
                                      sx={{
                                        backgroundColor:
                                          organizationSettings?.layoutColor,
                                        "&.MuiButton-root:hover": {
                                          backgroundColor:
                                            organizationSettings?.layoutColor,
                                        },
                                      }}
                                    >
                                      {this.state.creatingOrderWithSkipify && (
                                        <CircularProgress
                                          size={24}
                                          color="info"
                                        />
                                      )}
                                      <Typography
                                        sx={{
                                          fontSize: { xs: "16px" },
                                          fontWeight: 600,
                                        }}
                                      >
                                        Pay Now
                                      </Typography>
                                    </StyledPayButton>
                                  </div>
                                </Grid>
                              ) : (
                                <div style={{ padding: "8px" }}>
                                  <SkipifyIntegration
                                    cartRefId={this.state.skipifyGuid}
                                    merchantId={
                                      this.props.organizationSettings
                                        .skipifyMerchantID
                                    }
                                    onSuccess={(skipifyResponse: any) =>
                                      this.setState(
                                        { skipifyResponse: skipifyResponse },
                                        () => this.skipifySuccess()
                                      )
                                    }
                                    buttonColor={
                                      organizationSettings?.layoutColor
                                    }
                                    email={this.state.email}
                                    phone={this.state.phoneNumber}
                                    onClose={() => {
                                      this.setState({ skipifyClose: true });
                                    }}
                                    onClick={this.handleSkipifyClick}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                    {organizationSettings?.enablePayLater &&
                      <Grid item={true} xs={12} sm={12}>
                          <div style={{ textAlign: 'center', alignItems: 'center', justifyContent: 'center', margin: '8px' }}>
                              <StyledPayButton
                                  variant="contained"
                                  color="layoutColor"
                                  disableElevation
                                  disabled={isKitchenClosed() || isOrderEmpty || this.state.creatingOrder || this.payDisabled() || orderMinimumNotMet || loadPaymentUrl ||
                                  (
                                      this?.state?.orderType === 'Pickup' &&
                                      customName?.some((name:any, index:any) => {
                                      const matchingDelivery = pickupOverride.find((event:any) =>
                                          name === "" ? event.customName === "" : event.customName === name);
                                      const isRequired = matchingDelivery?.isRequiredForPickup === true;
                                      const hasValue = this.state.selectedNames[index] && this.state.selectedNames[index] !== '';
                                      return isRequired && !hasValue;
                                      })
                                  )
                                    ||
                                  (
                                      this.state.orderType === 'Delivery' &&
                                      customNames?.some((name:any, index:any) => {
                                      const matchingDelivery = pickupOverride.find((event:any) =>
                                          name === "" ? event.customName === "" : event.customName === name);
                                      const isRequired = matchingDelivery?.isRequiredForDelivery === true;
                                      const hasValue = this.state.selectedNames[index] && this.state.selectedNames[index] !== '';
                                      return isRequired && !hasValue;
                                      })
                                  )
                                    ||
                                  (
                                      this.state.orderType === 'Event' &&
                                      eventCustomNames?.some((name:any, index:any) => {
                                      const matchingDelivery = pickupOverride.find((event:any) =>
                                          name === "" ? event.customName === "" : event.customName === name);
                                      const isRequired = matchingDelivery?.isRequiredForEvent === true;
                                      const hasValue = this.state.selectedNames[index] && this.state.selectedNames[index] !== '';
                                      return isRequired && !hasValue;
                                      })
                                  )
                                    }
                                  sx={{ backgroundColor: organizationSettings?.layoutColor, '&.MuiButton-root:hover': { backgroundColor: organizationSettings?.layoutColor } }}
                                  onClick={this.payLater}
                              >
                                  {this.state.creatingOrder && <CircularProgress size={24} color="info" />}
                                  <Typography sx={
                                      {
                                          fontSize: { xs: '16px' },
                                          fontWeight: 600,
                                      }}>
                                      Pay Later
                                  </Typography>
                              </StyledPayButton>
                          </div>
                      </Grid>
                  }
                  </Box>
                </Hidden>
                {this.renderOnlineOrderClosedMessage(
                  onlineOrderEnabled,
                  onlineOrderClosedMessage
                )}
                {this.renderUndeliverableZoneMessage(
                  undeliverableZone,
                  undeliverableZoneMessage
                )}
                {this.renderThrottlingOverloadMessage(
                  throttlingBuffer === -1,
                  throttlingOverloadMessage
                )}
              </Grid>
              <Hidden only={["xs", "sm", "md"]}>
                <Grid item={true} xs={12} sm={4}>
                  <Container
                    sx={{
                      borderRadius: "30% 0% 0% 30%/70% 0% 0% 70%",
                      padding: "30px 50px",
                      maxWidth: 460,
                      width: 460,
                      position: "absolute" as "absolute",
                      right: 0,
                      top: 0,
                      left: "auto",
                      zIndex: 9999,
                      minHeight: "100%",
                      maxHeight: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                    component="main"
                    disableGutters={true}
                    maxWidth="md"
                    style={{
                      flexDirection: "column",
                      backgroundColor:
                        organizationSettings?.layoutColor &&
                        lighten(organizationSettings?.layoutColor, 0.5),
                    }}
                  >
                    <Grid
                      container={true}
                      sx={{ marginLeft: "20px", paddingLeft: "20px" }}
                    >
                      <Grid item={true} xs={12} sm={12}>
                        <div className={classes.cartScrollablePanel}>
                          {!this.props.isLoggedIn && (
                            <LoginUser {...this.props} />
                          )}
                          <Box
                            aria-label="show shopping cart"
                            color="inherit"
                            id="openModel"
                            sx={{
                              margin: 0,
                              padding: "8px 15px",
                              border: "1px solid",
                              borderColor: organizationSettings?.layoutColor,
                              borderRadius: "100px",
                              fontSize: "14px",
                              display: "flex",
                              backgroundColor: "#fff",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Stack direction="row" alignItems="center">
                              <img
                                src="/static/images/shopping-bag.svg"
                                alt=""
                                color="secondary"
                                style={{ marginRight: "5px" }}
                              />
                              <Typography sx={{ fontSize: { sm: "14px" } }}>
                                My order
                              </Typography>
                            </Stack>
                          </Box>
                          {!isOrderEmpty && (
                            <Box
                              sx={{
                                marginTop: "20px",
                                marginBottom: "10px",
                                fontSize: "18px",
                                fontWeight: 600,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: { sm: "16px" },
                                  fontWeight: 600,
                                  marginBottom: "5px",
                                }}
                              >
                                My orders
                              </Typography>
                            </Box>

                          )}
                          <Grid
                            container={true}
                            className={classNames(
                              classes.productDetailsItem,
                              isOrderEmpty ? classes.cartEmpty : ""
                            )}
                          >
                            {!isOrderEmpty ? (
                              order.orderItems?.map(
                                (orderItem: IOrderItem, index: number) => {
                                  const {
                                    name,
                                    price,
                                    id,
                                    quantity,
                                    orderItemModifiers,
                                  } = orderItem;

                                  let modifiers = getCheckedOptions(
                                    orderItemModifiers
                                  )?.map((orderItemModifier: any) => {
                                    const selectedSubOptions =
                                      orderItemModifier?.selectedSubOption;

                                    if (
                                      !selectedSubOptions ||
                                      selectedSubOptions.length === 0
                                    ) {
                                      return orderItemModifier?.name || "";
                                    }

                                    const selectedSubOption = selectedSubOptions
                                      .map((subOptionId: number) => {
                                        const subOption =
                                          orderItemModifier?.subOptions?.find(
                                            (sub: any) => sub.id === subOptionId
                                          );
                                        return subOption?.name;
                                      })
                                      .filter(Boolean);

                                    const subOptionsText =
                                      selectedSubOption.length > 0
                                        ? ` (${selectedSubOption.join(", ")})`
                                        : "";
                                    return `${
                                      orderItemModifier?.name || ""
                                    }${subOptionsText}`;
                                  });

                                  if (
                                    modifiers.length === 0 &&
                                    orderItemModifiers
                                  ) {
                                    modifiers = orderItemModifiers.flatMap(
                                      (orderItemModifier: any) => {
                                        return orderItemModifier.options
                                          .filter(
                                            (option: any) =>
                                              option.checked !== false
                                          )
                                          .map((option: any) => {
                                            const subOptionsText =
                                              option.subOptions.length > 0
                                                ? ` (${option.subOptions
                                                    .map((sub: any) => sub.name)
                                                    .join(", ")})`
                                                : "";
                                            return `${option.name}${subOptionsText}`;
                                          });
                                      }
                                    );
                                  }
                                return (
                                    <Grid
                                      item={true}
                                      xs={12}
                                      sm={12}
                                      key={id + "key" + index}
                                      sx={{
                                        width: "100%",
                                        margin: "4px 0px",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        backgroundColor: "white",
                                        padding: `${
                                          this.state.isDiscounts
                                          ? "15px 15px 5px 15px"
                                          : "0px 15px 5px 15px"
                                        }`,
                                        borderRadius: "12px",
                                      }}
                                    >
                                      {index === 0 &&
                                        this.state.isDiscounts && (
                                          <Stack
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            py={1}
                                            gap={1}
                                          >
                                            <StyledTextField
                                              name="discount"
                                              className={classes.marginBottom5}
                                              id="discount"
                                              label="Discount Code"
                                              onChange={(e: any) =>
                                                this.onhandleChange(
                                                  e,
                                                  "discount"
                                                )
                                              }
                                              fullWidth={true}
                                              variant="outlined"
                                              sx={{
                                                "& .MuiInputBase-root": {
                                                  height: 40,
                                                  padding: "0 8px",
                                                },
                                                "& .MuiInputLabel-root": {
                                                  fontSize: 15,
                                                  top: -5,
                                                },
                                                "& .MuiInputBase-input": {
                                                  padding: 0,
                                                  fontSize: 15,
                                                },
                                              }}
                                            />
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                gap: 1,
                                              }}
                                            >
                                              <StyledPayButton
                                                variant="contained"
                                                color="layoutColor"
                                                disabled={!this.state.discount}
                                                disableElevation
                                                sx={{
                                                  backgroundColor:
                                                    organizationSettings?.layoutColor,
                                                  padding: "12px",
                                                  "&.MuiButton-root:hover": {
                                                    backgroundColor:
                                                      organizationSettings?.layoutColor,
                                                  },
                                                }}
                                                onClick={this.discountTotalCode}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontSize: { xs: "12px" },
                                                    fontWeight: 600,
                                                  }}
                                                >
                                                  Apply
                                                </Typography>
                                              </StyledPayButton>
                                            </Box>
                                          </Stack>
                                        )}
                                      <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        py={1}
                                      >
                                        <Button
                                          sx={{
                                            color: "#000000",
                                            textAlign: "left",
                                            display: "block",
                                            width: "70%",
                                            px: 0,
                                          }}
                                          onClick={() =>
                                            this.backToProductEdit(orderItem)
                                          }
                                        >
                                          <Typography
                                            sx={{
                                              textOverflow: "ellipsis",
                                              overflow: "hidden",
                                              whiteSpace: "nowrap",
                                              fontSize: { xs: "16px" },
                                              fontWeight: 600,
                                            }}
                                          >
                                            {name}
                                          </Typography>
                                          <Box sx={{ textAlign: "left" }}>
                                            <Typography
                                              sx={{
                                                fontSize: { xs: "12px" },
                                                textTransform: "none",
                                                fontWeight: 400,
                                              }}
                                            >
                                              {modifiers.join(", ")}
                                            </Typography>
                                          </Box>
                                          <Box sx={{ textAlign: "left" }}>
                                            <Typography
                                              sx={{
                                                fontSize: { xs: "12px" },
                                                textTransform: "none",
                                                fontWeight: 400,
                                                color: "#000000",
                                              }}
                                            >
                                              {orderItem.notes}
                                            </Typography>
                                          </Box>
                                        </Button>
                                      </Stack>
                                      <Grid
                                        container={true}
                                        sx={{ mt: "-12px", ml: "-8px" }}
                                      >
                                        <Grid item={true} xs={12} sm={12}>
                                          <Stack
                                            direction="row"
                                            sx={{
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                pr: "20px",
                                              }}
                                            >
                                              <div>
                                                <ItemQtyDropdown
                                                  className={
                                                    classes?.qtyDropdown
                                                  }
                                                  dropdownOptions={
                                                    classes?.dropdownOptions
                                                  }
                                                  orderItem={orderItem}
                                                  onUpdateItemQuantity={
                                                    this.onUpdateItemQuantity
                                                  }
                                                />
                                                <div
                                                  className={classNames(
                                                    classes.errorMessage,
                                                    {
                                                      [classes.qtyErrorMessageActive]:
                                                        qtyError[id],
                                                    }
                                                  )}
                                                >
                                                  <span
                                                    style={{
                                                      display: qtyError[id]
                                                        ? "initial"
                                                        : "none",
                                                    }}
                                                  >
                                                    &nbsp;{qtyError[id]}
                                                  </span>
                                                </div>
                                              </div>
                                              <ClearOutlined
                                                sx={{
                                                  fontSize: { sm: "12px" },
                                                  marginBottom: "-1px",
                                                  mr: "10px",
                                                }}
                                              />
                                              <Typography
                                                sx={{
                                                  fontSize: { sm: "15px" },
                                                }}
                                              >
                                                $
                                                {formatMoney(
                                                  price +
                                                    getReorderModifiersPrice(
                                                      orderItemModifiers
                                                    )
                                                )}
                                              </Typography>
                                            </Box>
                                            <Button
                                              sx={{ justifyContent: "right" }}
                                            >
                                              <DeleteOutlined
                                                sx={{
                                                  fontSize: { sm: "15px" },
                                                  color: "#000000",
                                                  pr: "8px",
                                                  width: "auto",
                                                }}
                                                onClick={() =>
                                                  this.orderRemoveItem(id)
                                                }
                                              />
                                            </Button>
                                            <Box
                                              sx={{
                                                textAlign: "right",
                                                ml: "auto",
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: { sm: "15px" },
                                                  color:
                                                    organizationSettings?.layoutColor,
                                                  fontWeight: 500,
                                                }}
                                              >
                                                $
                                                {formatMoney(
                                                  (price +
                                                    getReorderModifiersPrice(
                                                      orderItemModifiers
                                                    )) *
                                                    quantity
                                                )}
                                              </Typography>
                                            </Box>
                                          </Stack>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  );
                                }
                              )
                            ) : (
                              <></>
                            )}
                          </Grid>
                        </div>
                          {!isOrderEmpty ? (
                            <OrderSummarySection
                              order={order}
                              subtotal={subtotal}
                              serviceChargeTotal={this.state.serviceChargeTotal}
                              gratuityTotal={this.state.gratuityTotal}
                              totalTax={totalTax}
                              deliveryFee={this.state.deliveryFee}
                              discountTotal={this.state.discountTotal}
                              total={total}
                              calculatePaymentLoading={calculatePaymentLoading}
                              orderType={orderType}
                              organizationSettings={organizationSettings}
                              classes={classes}
                            />
                          ) : (
                            <></>
                          )}
                          {!organizationSettings?.hideKitchenClosedMessage && isKitchenClosed() && (
                            <Stack
                              sx={{
                                background: "#ffc700",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%",
                                margin: "10px auto",
                                borderRadius: "12px",
                              }}
                            >
                              <Typography variant="caption">
                                Kitchen is closed at{" "}
                                {moment(
                                  orderType === "Event"
                                    ? moment(eventDate).format("YYYY-MM-DD") +
                                    moment(this.state.eventFieldStartTime)
                                      .utc()
                                      .format("THH:mm:ss.SSS[Z]")
                                    : this.state.requestedPickupAndDeliveryTime
                                ).format("h:mm A")}
                              </Typography>
                            </Stack>
                          )}
                          <PaymentSection
                            organizationSettings={organizationSettings}
                            isKitchenClosed={isKitchenClosed()}
                            isOrderEmpty={isOrderEmpty}
                            creatingOrder={this.state.creatingOrder}
                            creatingOrderWithSkipify={
                              this.state.creatingOrderWithSkipify
                            }
                            onHoverSkipifyButton={() => this.validateOrderMenuCategoryItems()}
                            isDisabled={
                              isKitchenClosed() ||
                              isOrderEmpty ||
                              this.state.creatingOrder ||
                              this.state.creatingOrderWithSkipify ||
                              this.payDisabled() ||
                              orderMinimumNotMet ||
                              loadPaymentUrl ||
                              (this.state.orderType === 'Event' && (
                                !this.state.expectedGuestCount ||
                                !this.isEventDateValid() ||
                                !this.state.eventStart ||
                                !this.state.eventEnd
                              )) ||
                              (this?.state?.orderType === "Pickup" &&
                                customName?.some((name: any, index: any) => {
                                  const matchingDelivery = pickupOverride.find(
                                    (event: any) =>
                                      name === ""
                                        ? event.customName === ""
                                        : event.customName === name
                                  );
                                  const isRequired =
                                    matchingDelivery?.isRequiredForPickup ===
                                    true;
                                  const hasValue =
                                    this.state.selectedNames[index] &&
                                    this.state.selectedNames[index] !== "";
                                  return isRequired && !hasValue;
                                })) ||
                              (this.state.orderType === "Delivery" &&
                                customNames?.some((name: any, index: any) => {
                                  const matchingDelivery = pickupOverride.find(
                                    (event: any) =>
                                      name === ""
                                        ? event.customName === ""
                                        : event.customName === name
                                  );
                                  const isRequired =
                                    matchingDelivery?.isRequiredForDelivery ===
                                    true;
                                  const hasValue =
                                    this.state.selectedNames[index] &&
                                    this.state.selectedNames[index] !== "";
                                  return isRequired && !hasValue;
                                })) ||
                              (this.state.orderType === "Event" &&
                                eventCustomNames?.some((name: any, index: any) => {
                                  const matchingDelivery = pickupOverride.find(
                                    (event: any) =>
                                      name === ""
                                        ? event.customName === ""
                                        : event.customName === name
                                  );
                                  const isRequired =
                                    matchingDelivery?.isRequiredForEvent === true;
                                  const hasValue =
                                    this.state.selectedNames[index] &&
                                    this.state.selectedNames[index] !== "";
                                  return isRequired && !hasValue;
                                }))
                            }
                            email={this.state.email}
                            phoneNumber={this.state.phoneNumber}
                            skipifyGuid={this.state.skipifyGuid}
                            total={this.state.total}
                            onPayNow={this.payNow}
                            onPayLater={this.payLater}
                            onSkipifyClick={this.handleSkipifyClick}
                            onSkipifySuccess={(skipifyResponse: any) =>
                              this.setState(
                                {
                                  skipifyResponse: skipifyResponse,
                                },
                                () => this.skipifySuccess()
                              )
                            }
                            onSkipifyClose={() => {
                              this.setState({
                                skipifyClose: true,
                              });
                            }}
                          />
                          {isOrderEmpty ? (
                            <Grid
                              container={true}
                              key={"empt-cart-image"}
                              sx={{
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Grid item={true} xs={12} sm={12}>
                                <Typography
                                  variant="body2"
                                  align="center"
                                  gutterBottom={true}
                                  style={{
                                    position: "sticky",
                                    color: "#000000",
                                    fontWeight: 600,
                                    transform: "translateY(-70px)",
                                  }}
                                >
                                  Your cart is empty.
                                </Typography>
                              </Grid>
                              <Grid item={true} xs={12} sm={12}>
                                <Box
                                  sx={{
                                    textAlign: "center",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    margin: "8px",
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    disableElevation={true}
                                    disableRipple={true}
                                    sx={{
                                      minWidth: "50%",
                                      margin: "10px",
                                      borderRadius: "12px",
                                      textTransform: "none",
                                      backgroundColor:
                                        organizationSettings?.layoutColor,
                                      "&.MuiButton-root:hover": {
                                        backgroundColor:
                                          organizationSettings?.layoutColor,
                                      },
                                    }}
                                    onClick={this.goToDashboard}
                                  >
                                    Add Items to Cart
                                  </Button>
                                </Box>
                              </Grid>
                            </Grid>
                          ) : (
                            <></>
                          )}
                      </Grid>
                    </Grid>
                  </Container>
                </Grid>
              </Hidden>
            </Grid >
          ) : (
            <Stack alignItems={"center"} justifyContent={"center"}>
              <CircularProgress color="secondary" />
            </Stack>
          )
          }
          <OpenHoursDialog
            open={openOpenHoursModel}
            onClose={() => this.handleCloseOpenHoursModel()}
            organization={{ name: organization?.name }}
            organizationSettings={organizationSettings}
            schedule={schedule}
            formattedHolidays={formattedHolidays}
            formatDateForTimezone={formatDateForTimezone}
            contentHeight={this.state.paymentDialogHeight}
          />
          <StorePolicyDialog
            open={openPolicyModel}
            onClose={() => {this.handleClosePolicyModel()}}
            organization={organization}
            organizationSettings={organizationSettings}
            contentHeight={this.state.paymentDialogHeight}
            orderType={this.state.orderType}
            isScheduleNotFound={this.state.isOpenScheduleReturnedMessage}
          />
          <Dialog
            aria-labelledby="customized-dialog-title"
            open={openPayMethodModel}
            className={classes.paymentDialog}
            disableEscapeKeyDown={true}
            hideBackdrop={true}
            PaperProps={{
              style: {
                border: "3px solid",
                borderColor:
                  organizationSettings?.layoutColor &&
                  lighten(organizationSettings?.layoutColor, 0.5),
                borderRadius: "12px",
                overflowX: "hidden",
                width: "675px",
                maxWidth: "675px",
                maxHeight: "calc(100% - 40px)",
              },
            }}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={() => this.handleClosePayMethodModel()}
              className={classes.dialogTitle}
              classes={{ closeButton: classes.closeButton }}
              sx={{
                p: "0px 24px",
                "& svg": {
                  width: 25,
                },
              }}
            />
            <DialogContent style={{ height: "100%" }} sx={{ p: 0 }}>
              <Box>
                <Typography
                  sx={{
                    mb: 2,
                    textAlign: "center",
                    fontSize: { xs: "20px" },
                    fontFamily: "Verdana, sans-serif",
                    fontWeight: 400,
                  }}
                >
                  Payment Details
                </Typography>
                {this.state.paymentDeclineError && (
                  <div>
                    <Typography
                      sx={{
                        mb: 2,
                        color: "red",
                        textAlign: "center",
                        fontSize: { xs: "20px" },
                        fontFamily: "Verdana, sans-serif",
                        fontWeight: 400,
                      }}
                    >
                      {this.state.paymentDeclineError}
                    </Typography>
                  </div>
                )}
                {this.paymentCompleted && this.state.paymentConfirmation && (
                  <PaymentDetails transactions={[this.state.paymentConfirmation]} />
                )}
                  <div style={{ display: this.paymentSubmitted || this.paymentCompleted ? "none" : undefined }}>
                    {!paymentPayload && (
                      <form
                        name="hpay-model-window"
                        style={{ alignItems: "center" }}
                      >
                        {orderType === "Pickup" && (
                          <Box sx={{ position: "relative", marginX: "30px" }}>
                            <Grid container={true}>
                              <Grid item xs={12} sm={12}>
                                <Grid container sx={{ marginBottom: "10px" }}>
                                  <Grid item={true} xs={4} sm={4}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: {
                                          xs: "16px",
                                          color: "#000000",
                                        },
                                      }}
                                    >
                                      Pickup Address:
                                    </Typography>
                                  </Grid>
                                  <Grid item={true} xs={8} sm={8}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: {
                                          xs: "16px",
                                          color: "#000000",
                                        },
                                      }}
                                    >
                                      {`${organization?.address1
                                        ? `${organization?.address1},`
                                        : ""
                                        } ${organization?.address2
                                          ? `${organization?.address2}`
                                          : ""
                                        }`}{" "}
                                      {organization?.city
                                        ? `${organization?.city},`
                                        : ""}{" "}
                                      {organization?.stateProvince
                                        ? `${organization?.stateProvince},`
                                        : ""}{" "}
                                      {organization?.postalCode
                                        ? `${organization?.postalCode}`
                                        : ""}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12} sm={12}>
                                <Grid container sx={{ marginBottom: "10px" }}>
                                  <Grid item={true} xs={4} sm={4}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: { xs: "16px" },
                                        color: "#000000",
                                        paddingRight: { xs: "1px", sm: "0px" },
                                      }}
                                    >
                                      Pickup Time:
                                    </Typography>
                                  </Grid>
                                  <Grid item={true} xs={8} sm={8}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: {
                                          xs: "16px",
                                          color: "#000000",
                                        },
                                      }}
                                    >
                                      {moment(
                                        this.state
                                          .requestedPickupAndDeliveryTime
                                      ).format("h:mma")}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>
                        )}
                        {orderType === "Delivery" && (
                          <Box sx={{ position: "relative", marginX: "31px" }}>
                            <Grid container={true}>
                              <Grid item xs={12} sm={12}>
                                <Grid container sx={{ marginBottom: "10px" }}>
                                  <Grid item={true} xs={4} sm={4}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: {
                                          xs: "16px",
                                          color: "#000000",
                                        },
                                      }}
                                    >
                                      Delivery Address:
                                    </Typography>
                                  </Grid>
                                  <Grid item={true} xs={8} sm={8}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: {
                                          xs: "16px",
                                          color: "#000000",
                                        },
                                      }}
                                    >
                                      {replaceComma(
                                        this.getOrderDeliveryAddress()
                                          ?.address1 || ""
                                      )}{" "}
                                      {this.getOrderDeliveryAddress()?.city}{" "}
                                      {
                                        this.getOrderDeliveryAddress()
                                          ?.stateProvince
                                      }{" "}
                                      {
                                        this.getOrderDeliveryAddress()
                                          ?.postalCode
                                      }
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid item xs={12} sm={12}>
                                <Grid container sx={{ marginBottom: "10px" }}>
                                  <Grid item={true} xs={4} sm={4}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: { xs: "16px" },
                                        color: "#000000",
                                      }}
                                    >
                                      Delivery Time:
                                    </Typography>
                                  </Grid>
                                  <Grid item={true} xs={8} sm={8}>
                                    <Typography
                                      sx={{
                                        fontFamily: "Verdana, sans-serif",
                                        fontWeight: 400,
                                        fontSize: {
                                          xs: "16px",
                                          color: "#000000",
                                        },
                                      }}
                                    >
                                     {moment(this.state.requestedPickupAndDeliveryTime).format("h:mma")}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              {this.state.orderType === "Delivery" && (
                                <Grid item xs={12} sm={12}>
                                  <Grid container sx={{ marginBottom: "10px" }}>
                                    <Grid item={true} xs={4} sm={4}>
                                      <Typography
                                        sx={{
                                          fontFamily: "Verdana, sans-serif",
                                          fontWeight: 400,
                                          fontSize: { xs: "16px" },
                                          color: "#000000",
                                        }}
                                      >
                                        Delivery Fee:
                                      </Typography>
                                    </Grid>
                                    <Grid item={true} xs={8} sm={8}>
                                      <Typography
                                        sx={{
                                          fontFamily: "Verdana, sans-serif",
                                          fontWeight: 400,
                                          fontSize: {
                                            xs: "16px",
                                            color: "#000000",
                                          },
                                        }}
                                      >
                                        {"$" +
                                          formatMoney(
                                            this.state.deliveryFee || 0
                                          )}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Box>
                        )}
                        <iframe
                          ref={this.paymentFrame}
                          id="payment-form"
                          title="Payment form"
                          scrolling="auto"
                          className={classes.iframeRoot}
                          src={this.state.paymentURL || ""}
                        ></iframe>
                      </form>
                    )}
                    {paymentPayload && this.state.cardDetailsLoader && (
                      <Stack
                        sx={{ p: 10 }}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <CircularProgress size={50} color="info" />
                      </Stack>
                    )}
                    {paymentPayload && !this.state.cardDetailsLoader && (
                      <Stack
                        sx={{ p: 10 }}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <CircularProgress size={50} color="info" />
                      </Stack>
                    )}
                  </div>
              </Box>
            </DialogContent>
          </Dialog>
          <Snackbar
            open={this.state.orderCreateError}
            autoHideDuration={3000}
            onClose={() =>
              this.setState({
                orderCreateError: false,
                orderCreateErrorMessage: "",
              })
            }
          >
            <SnackbarContent
              sx={{
                backgroundColor: "#d32f2f",
              }}
              message={
                <Stack direction={"row"} alignItems={"center"} spacing={2}>
                  <span>
                    {this.state.orderCreateErrorMessage ||
                      "Something went wrong, can't create order."}
                  </span>
                  <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={() => {
                      this.setState({
                        orderCreateError: false,
                        orderCreateErrorMessage: "",
                      });
                    }}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </Stack>
              }
            />
          </Snackbar>
        </div >
      </Auth0Provider >
    );
  }

  checkRequiredFields = () => {
    const hasAnyRequiredField = this.props.pickListByOrganization?.some(
      (item: any) =>
        item?.isRequiredForEvent ||
        item?.isRequiredForDelivery ||
        item?.isRequiredForPickup
    );
    return hasAnyRequiredField;
  };
}

const mapStateToProps = (state: AppState) => ({
  utility: state.utility,
  oidc: state.user?.user,
  order: state.order,
  user: state?.user?.auth0UserDetails,
  appUserDetails: state?.user?.appUserDetails,
  isGuestLogin: !!state.user && state.user?.user?.profile?.name === "Guest",
  isLoggedIn: !!state.user.auth0UserDetails,
  locationId: state.user ? state.user?.user?.profile?.location_id : "",
  settings: state.settings?.SettingsKeyValue,
  customer: state.customer,
  rooms: state?.room?.rooms,
  eventPickLists: state?.pickList?.eventPickLists,
  organizationSettings: state?.organizations?.organizationSettings,
  organizationOrdersOpenSchedule:
    state?.organizations?.organizationOrdersOpenSchedule,
  organizations: state?.organizations,
  organization: state?.organizations?.organization,
  userPersonalDetails: state?.organizations?.userDetails,
  layoutColor: state?.organizations?.organizationSettings?.layoutColor,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      orderGet: OrderActions.get,
      orderPut: OrderActions.put,
      orderSetDefault: OrderActions.setDefault,
      orderRemoveItem: OrderActions.removeItem,
      applyCoupon: OrderActions.ApplyCoupon,
      removeCoupon: OrderActions.RemoveCoupon,
      contactPost: ContactActions.post,
      handleClickOpenSignInModel: AppActions.handleClickOpenSignInModel,
      makePayment: PaymentActions.makePayment,
      openProductDetailPageModel,
      selectedCategoryMenuProduct,
      getSettingAreas,
      getRooms,
      upsertAddress: UpsertAddress,
      createOrderGuest: createGuestOrder,
      validateGuestOrder: validatetOrders,
      validateMenuCategoryItems: validateMenuCategoryItems,
      clearCart: OrderActions.removeCart,
      getPaymentCardDetails: getPaymentCardDetails,
      getOrganizationSettings: OrganizationActions.getOrganizationSettings,
      getOrganizationOrdersOpenSchedule: OrganizationActions.getOrganizationOrdersOpenSchedule,
      getOrganizations: OrganizationActions.getOrganization,
      getSetupIntentDetails: getSetupIntentDetail,
      postPaymentForOrder: postPaymentForOrder,
      getUserByEmailId: OrderActions.getUserByEmailId,
      registerUser: OrderActions.registerUser,
      fetchCalculatedPayment: getCalculatedPayment,
      fetchCalculatedEstimatedTime: getCalculatedEstimatedTime,
      addressesGet: ContactActions.getSavedAddresses,
      fetchUndeliverablePostalCodes: getUndeliverablePostalCodes,
      postCreatePaymentLink: postCreatePaymentLink,
      getPickListOptionsFromAPI: getEventPicklistsOptions,
      getPickLists: getPickListsByOrganization,
      createNewAddress: ContactActions.createNewAddress,
    },
    dispatch
  );

const ProceedToCheckoutView = withRouter(ProceedToCheckout);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles as any)(ProceedToCheckoutView as any));
